// Region data mapped by country code
export const regionData = [
  {
    "countryCode": "AD",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "AE",
    "region": "1",
    "description": "EASTERN REGION"
  },
  {
    "countryCode": "AE",
    "region": "2",
    "description": "WESTERN REGION"
  },
  {
    "countryCode": "AE",
    "region": "3",
    "description": "NORTH REGION"
  },
  {
    "countryCode": "AE",
    "region": "4",
    "description": "SOUTH REGION"
  },
  {
    "countryCode": "AE",
    "region": "5",
    "description": "Dubai"
  },
  {
    "countryCode": "AE",
    "region": "6",
    "description": "Abu Dhabi"
  },
  {
    "countryCode": "AF",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "AG",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "AI",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "AL",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "AM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "AN",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "AO",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "AQ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "AR",
    "region": "0",
    "description": "Capital Federal"
  },
  {
    "countryCode": "AR",
    "region": "1",
    "description": "Buenos Aires"
  },
  {
    "countryCode": "AR",
    "region": "2",
    "description": "Catamarca"
  },
  {
    "countryCode": "AR",
    "region": "3",
    "description": "Córdoba"
  },
  {
    "countryCode": "AR",
    "region": "4",
    "description": "Corrientes"
  },
  {
    "countryCode": "AR",
    "region": "5",
    "description": "Entre Rios"
  },
  {
    "countryCode": "AR",
    "region": "6",
    "description": "Jujuy"
  },
  {
    "countryCode": "AR",
    "region": "7",
    "description": "Mendoza"
  },
  {
    "countryCode": "AR",
    "region": "8",
    "description": "La Rioja"
  },
  {
    "countryCode": "AR",
    "region": "9",
    "description": "Salta"
  },
  {
    "countryCode": "AR",
    "region": "10",
    "description": "San Juan"
  },
  {
    "countryCode": "AR",
    "region": "11",
    "description": "San Luis"
  },
  {
    "countryCode": "AR",
    "region": "12",
    "description": "Santa Fé"
  },
  {
    "countryCode": "AR",
    "region": "13",
    "description": "Santiago del Estero"
  },
  {
    "countryCode": "AR",
    "region": "14",
    "description": "Tucumán"
  },
  {
    "countryCode": "AR",
    "region": "16",
    "description": "Chaco"
  },
  {
    "countryCode": "AR",
    "region": "17",
    "description": "Chubut"
  },
  {
    "countryCode": "AR",
    "region": "18",
    "description": "Formosa"
  },
  {
    "countryCode": "AR",
    "region": "19",
    "description": "Misiones"
  },
  {
    "countryCode": "AR",
    "region": "20",
    "description": "Neuquen"
  },
  {
    "countryCode": "AR",
    "region": "21",
    "description": "La Pampa"
  },
  {
    "countryCode": "AR",
    "region": "22",
    "description": "Rio Negro"
  },
  {
    "countryCode": "AR",
    "region": "23",
    "description": "Santa Cruz"
  },
  {
    "countryCode": "AR",
    "region": "24",
    "description": "Tierra de Fuego"
  },
  {
    "countryCode": "AS",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "AT",
    "region": "B",
    "description": "Burgenland"
  },
  {
    "countryCode": "AT",
    "region": "K",
    "description": "Carinthia"
  },
  {
    "countryCode": "AT",
    "region": "NÖ",
    "description": "Lower Austria"
  },
  {
    "countryCode": "AT",
    "region": "OÖ",
    "description": "Upper Austria"
  },
  {
    "countryCode": "AT",
    "region": "S",
    "description": "Salzburg"
  },
  {
    "countryCode": "AT",
    "region": "ST",
    "description": "Styria"
  },
  {
    "countryCode": "AT",
    "region": "T",
    "description": "Tyrol"
  },
  {
    "countryCode": "AT",
    "region": "V",
    "description": "Vorarlberg"
  },
  {
    "countryCode": "AT",
    "region": "W",
    "description": "Vienna"
  },
  {
    "countryCode": "AU",
    "region": "ACT",
    "description": "Aust Capital Terr"
  },
  {
    "countryCode": "AU",
    "region": "NSW",
    "description": "New South Wales"
  },
  {
    "countryCode": "AU",
    "region": "NT",
    "description": "Northern Territory"
  },
  {
    "countryCode": "AU",
    "region": "QLD",
    "description": "Queensland"
  },
  {
    "countryCode": "AU",
    "region": "SA",
    "description": "South Australia"
  },
  {
    "countryCode": "AU",
    "region": "TAS",
    "description": "Tasmania"
  },
  {
    "countryCode": "AU",
    "region": "VIC",
    "description": "Victoria"
  },
  {
    "countryCode": "AU",
    "region": "WA",
    "description": "Western Australia"
  },
  {
    "countryCode": "AW",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "AZ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "BA",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "BB",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "BD",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "BE",
    "region": "1",
    "description": "Antwerp"
  },
  {
    "countryCode": "BE",
    "region": "2",
    "description": "Brabant (Flemish)"
  },
  {
    "countryCode": "BE",
    "region": "3",
    "description": "Hainaut"
  },
  {
    "countryCode": "BE",
    "region": "4",
    "description": "Liege"
  },
  {
    "countryCode": "BE",
    "region": "5",
    "description": "Limburg"
  },
  {
    "countryCode": "BE",
    "region": "6",
    "description": "Luxembourg"
  },
  {
    "countryCode": "BE",
    "region": "7",
    "description": "Namur"
  },
  {
    "countryCode": "BE",
    "region": "8",
    "description": "Oost-Vlaanderen"
  },
  {
    "countryCode": "BE",
    "region": "9",
    "description": "West-Vlaanderen"
  },
  {
    "countryCode": "BE",
    "region": "10",
    "description": "Brabant (Walloon)"
  },
  {
    "countryCode": "BE",
    "region": "11",
    "description": "Brussels (Capital)"
  },
  {
    "countryCode": "BF",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "BG",
    "region": "1",
    "description": "Burgas"
  },
  {
    "countryCode": "BG",
    "region": "2",
    "description": "Grad Sofiya"
  },
  {
    "countryCode": "BG",
    "region": "3",
    "description": "Khaskovo"
  },
  {
    "countryCode": "BG",
    "region": "4",
    "description": "Lovech"
  },
  {
    "countryCode": "BG",
    "region": "5",
    "description": "Montana"
  },
  {
    "countryCode": "BG",
    "region": "6",
    "description": "Plovdiv"
  },
  {
    "countryCode": "BG",
    "region": "7",
    "description": "Ruse"
  },
  {
    "countryCode": "BG",
    "region": "8",
    "description": "Sofiya"
  },
  {
    "countryCode": "BG",
    "region": "9",
    "description": "Varna"
  },
  {
    "countryCode": "BH",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "BI",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "BJ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "BM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "BN",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "BO",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "BR",
    "region": "AC",
    "description": "Acre"
  },
  {
    "countryCode": "BR",
    "region": "AL",
    "description": "Alagoas"
  },
  {
    "countryCode": "BR",
    "region": "AM",
    "description": "Amazon"
  },
  {
    "countryCode": "BR",
    "region": "AP",
    "description": "Amapá"
  },
  {
    "countryCode": "BR",
    "region": "BA",
    "description": "Bahia"
  },
  {
    "countryCode": "BR",
    "region": "CE",
    "description": "Ceará"
  },
  {
    "countryCode": "BR",
    "region": "DF",
    "description": "Brasília"
  },
  {
    "countryCode": "BR",
    "region": "ES",
    "description": "Espírito Santo"
  },
  {
    "countryCode": "BR",
    "region": "GO",
    "description": "Goiás"
  },
  {
    "countryCode": "BR",
    "region": "MA",
    "description": "Maranhão"
  },
  {
    "countryCode": "BR",
    "region": "MG",
    "description": "Minas Gerais"
  },
  {
    "countryCode": "BR",
    "region": "MS",
    "description": "Mato Grosso do Sul"
  },
  {
    "countryCode": "BR",
    "region": "MT",
    "description": "Mato Grosso"
  },
  {
    "countryCode": "BR",
    "region": "PA",
    "description": "Pará"
  },
  {
    "countryCode": "BR",
    "region": "PB",
    "description": "Paraíba"
  },
  {
    "countryCode": "BR",
    "region": "PE",
    "description": "Pernambuco"
  },
  {
    "countryCode": "BR",
    "region": "PI",
    "description": "Piauí"
  },
  {
    "countryCode": "BR",
    "region": "PR",
    "description": "Paraná"
  },
  {
    "countryCode": "BR",
    "region": "RJ",
    "description": "Rio de Janeiro"
  },
  {
    "countryCode": "BR",
    "region": "RN",
    "description": "Rio Grande do Norte"
  },
  {
    "countryCode": "BR",
    "region": "RO",
    "description": "Rondônia"
  },
  {
    "countryCode": "BR",
    "region": "RR",
    "description": "Roraima"
  },
  {
    "countryCode": "BR",
    "region": "RS",
    "description": "Rio Grande do Sul"
  },
  {
    "countryCode": "BR",
    "region": "SC",
    "description": "Santa Catarina"
  },
  {
    "countryCode": "BR",
    "region": "SE",
    "description": "Sergipe"
  },
  {
    "countryCode": "BR",
    "region": "SP",
    "description": "São Paulo"
  },
  {
    "countryCode": "BR",
    "region": "TO",
    "description": "Tocantins"
  },
  {
    "countryCode": "BS",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "BT",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "BV",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "BW",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "BY",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "BZ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CA",
    "region": "AB",
    "description": "Alberta"
  },
  {
    "countryCode": "CA",
    "region": "BC",
    "description": "British Columbia"
  },
  {
    "countryCode": "CA",
    "region": "MB",
    "description": "Manitoba"
  },
  {
    "countryCode": "CA",
    "region": "NB",
    "description": "New Brunswick"
  },
  {
    "countryCode": "CA",
    "region": "NL",
    "description": "Newfoundland/Labrad."
  },
  {
    "countryCode": "CA",
    "region": "NS",
    "description": "Nova Scotia"
  },
  {
    "countryCode": "CA",
    "region": "NT",
    "description": "Northwest Terr."
  },
  {
    "countryCode": "CA",
    "region": "NU",
    "description": "Nunavut"
  },
  {
    "countryCode": "CA",
    "region": "ON",
    "description": "Ontario"
  },
  {
    "countryCode": "CA",
    "region": "PE",
    "description": "Prince Edward Island"
  },
  {
    "countryCode": "CA",
    "region": "QC",
    "description": "Quebec"
  },
  {
    "countryCode": "CA",
    "region": "SK",
    "description": "Saskatchewan"
  },
  {
    "countryCode": "CA",
    "region": "YT",
    "description": "Yukon Territory"
  },
  {
    "countryCode": "CC",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CD",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CF",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CG",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CH",
    "region": "AG",
    "description": "Aargau"
  },
  {
    "countryCode": "CH",
    "region": "AI",
    "description": "Inner-Rhoden"
  },
  {
    "countryCode": "CH",
    "region": "AR",
    "description": "Ausser-Rhoden"
  },
  {
    "countryCode": "CH",
    "region": "BE",
    "description": "Bern"
  },
  {
    "countryCode": "CH",
    "region": "BL",
    "description": "Basel Land"
  },
  {
    "countryCode": "CH",
    "region": "BS",
    "description": "Basel Stadt"
  },
  {
    "countryCode": "CH",
    "region": "FR",
    "description": "Fribourg"
  },
  {
    "countryCode": "CH",
    "region": "GE",
    "description": "Geneva"
  },
  {
    "countryCode": "CH",
    "region": "GL",
    "description": "Glarus"
  },
  {
    "countryCode": "CH",
    "region": "GR",
    "description": "Graubuenden"
  },
  {
    "countryCode": "CH",
    "region": "JU",
    "description": "Jura"
  },
  {
    "countryCode": "CH",
    "region": "LU",
    "description": "Lucerne"
  },
  {
    "countryCode": "CH",
    "region": "NE",
    "description": "Neuchatel"
  },
  {
    "countryCode": "CH",
    "region": "NW",
    "description": "Nidwalden"
  },
  {
    "countryCode": "CH",
    "region": "OW",
    "description": "Obwalden"
  },
  {
    "countryCode": "CH",
    "region": "SG",
    "description": "St. Gallen"
  },
  {
    "countryCode": "CH",
    "region": "SH",
    "description": "Schaffhausen"
  },
  {
    "countryCode": "CH",
    "region": "SO",
    "description": "Solothurn"
  },
  {
    "countryCode": "CH",
    "region": "SZ",
    "description": "Schwyz"
  },
  {
    "countryCode": "CH",
    "region": "TG",
    "description": "Thurgau"
  },
  {
    "countryCode": "CH",
    "region": "TI",
    "description": "Ticino"
  },
  {
    "countryCode": "CH",
    "region": "UR",
    "description": "Uri"
  },
  {
    "countryCode": "CH",
    "region": "VD",
    "description": "Vaud"
  },
  {
    "countryCode": "CH",
    "region": "VS",
    "description": "Valais"
  },
  {
    "countryCode": "CH",
    "region": "ZG",
    "description": "Zug"
  },
  {
    "countryCode": "CH",
    "region": "ZH",
    "description": "Zurich"
  },
  {
    "countryCode": "CI",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CK",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CL",
    "region": "1",
    "description": "I - Iquique"
  },
  {
    "countryCode": "CL",
    "region": "2",
    "description": "II - Antofagasta"
  },
  {
    "countryCode": "CL",
    "region": "3",
    "description": "III - Copiapo"
  },
  {
    "countryCode": "CL",
    "region": "4",
    "description": "IV - La Serena"
  },
  {
    "countryCode": "CL",
    "region": "5",
    "description": "V - Valparaiso"
  },
  {
    "countryCode": "CL",
    "region": "6",
    "description": "VI - Rancagua"
  },
  {
    "countryCode": "CL",
    "region": "7",
    "description": "VII - Talca"
  },
  {
    "countryCode": "CL",
    "region": "8",
    "description": "VIII - Concepción"
  },
  {
    "countryCode": "CL",
    "region": "9",
    "description": "IX - Temuco"
  },
  {
    "countryCode": "CL",
    "region": "10",
    "description": "X - Puerto Montt"
  },
  {
    "countryCode": "CL",
    "region": "11",
    "description": "XI - Coyhaique"
  },
  {
    "countryCode": "CL",
    "region": "12",
    "description": "XII - Punta Arenas"
  },
  {
    "countryCode": "CL",
    "region": "13",
    "description": "RM - Santiago"
  },
  {
    "countryCode": "CM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CN",
    "region": "10",
    "description": "Beijing"
  },
  {
    "countryCode": "CN",
    "region": "20",
    "description": "Shanghai"
  },
  {
    "countryCode": "CN",
    "region": "30",
    "description": "Tianjin"
  },
  {
    "countryCode": "CN",
    "region": "40",
    "description": "Nei Mongol"
  },
  {
    "countryCode": "CN",
    "region": "50",
    "description": "Shanxi"
  },
  {
    "countryCode": "CN",
    "region": "60",
    "description": "Hebei"
  },
  {
    "countryCode": "CN",
    "region": "70",
    "description": "Liaoning"
  },
  {
    "countryCode": "CN",
    "region": "80",
    "description": "Jilin"
  },
  {
    "countryCode": "CN",
    "region": "90",
    "description": "Heilongjiang"
  },
  {
    "countryCode": "CN",
    "region": "100",
    "description": "Jiangsu"
  },
  {
    "countryCode": "CN",
    "region": "110",
    "description": "Anhui"
  },
  {
    "countryCode": "CN",
    "region": "120",
    "description": "Shandong"
  },
  {
    "countryCode": "CN",
    "region": "130",
    "description": "Zhejiang"
  },
  {
    "countryCode": "CN",
    "region": "140",
    "description": "Jiangxi"
  },
  {
    "countryCode": "CN",
    "region": "150",
    "description": "Fujian"
  },
  {
    "countryCode": "CN",
    "region": "160",
    "description": "Hunan"
  },
  {
    "countryCode": "CN",
    "region": "170",
    "description": "Hubei"
  },
  {
    "countryCode": "CN",
    "region": "180",
    "description": "Henan"
  },
  {
    "countryCode": "CN",
    "region": "190",
    "description": "Guangdong"
  },
  {
    "countryCode": "CN",
    "region": "200",
    "description": "Hainan"
  },
  {
    "countryCode": "CN",
    "region": "210",
    "description": "Guangxi"
  },
  {
    "countryCode": "CN",
    "region": "220",
    "description": "Guizhou"
  },
  {
    "countryCode": "CN",
    "region": "230",
    "description": "Sichuan"
  },
  {
    "countryCode": "CN",
    "region": "240",
    "description": "Yunnan"
  },
  {
    "countryCode": "CN",
    "region": "250",
    "description": "Shaanxi"
  },
  {
    "countryCode": "CN",
    "region": "260",
    "description": "Gansu"
  },
  {
    "countryCode": "CN",
    "region": "270",
    "description": "Ningxia"
  },
  {
    "countryCode": "CN",
    "region": "280",
    "description": "Qinghai"
  },
  {
    "countryCode": "CN",
    "region": "290",
    "description": "Xinjiang"
  },
  {
    "countryCode": "CN",
    "region": "300",
    "description": "Xizang"
  },
  {
    "countryCode": "CN",
    "region": "320",
    "description": "Chong Qing"
  },
  {
    "countryCode": "CO",
    "region": "5",
    "description": "ANTIOQUIA"
  },
  {
    "countryCode": "CO",
    "region": "8",
    "description": "ATLANTICO"
  },
  {
    "countryCode": "CO",
    "region": "11",
    "description": "BOGOTA"
  },
  {
    "countryCode": "CO",
    "region": "13",
    "description": "BOLIVAR"
  },
  {
    "countryCode": "CO",
    "region": "15",
    "description": "BOYACA"
  },
  {
    "countryCode": "CO",
    "region": "17",
    "description": "CALDAS"
  },
  {
    "countryCode": "CO",
    "region": "18",
    "description": "CAQUETA"
  },
  {
    "countryCode": "CO",
    "region": "19",
    "description": "CAUCA"
  },
  {
    "countryCode": "CO",
    "region": "20",
    "description": "CESAR"
  },
  {
    "countryCode": "CO",
    "region": "23",
    "description": "CORDOBA"
  },
  {
    "countryCode": "CO",
    "region": "25",
    "description": "CUNDINAMARCA"
  },
  {
    "countryCode": "CO",
    "region": "27",
    "description": "CHOCO"
  },
  {
    "countryCode": "CO",
    "region": "41",
    "description": "HUILA"
  },
  {
    "countryCode": "CO",
    "region": "44",
    "description": "LA GUAJIRA"
  },
  {
    "countryCode": "CO",
    "region": "47",
    "description": "MAGDALENA"
  },
  {
    "countryCode": "CO",
    "region": "50",
    "description": "META"
  },
  {
    "countryCode": "CO",
    "region": "52",
    "description": "NARIÑO"
  },
  {
    "countryCode": "CO",
    "region": "54",
    "description": "NORTE SANTANDER"
  },
  {
    "countryCode": "CO",
    "region": "63",
    "description": "QUINDIO"
  },
  {
    "countryCode": "CO",
    "region": "66",
    "description": "RISARALDA"
  },
  {
    "countryCode": "CO",
    "region": "68",
    "description": "SANTANDER"
  },
  {
    "countryCode": "CO",
    "region": "70",
    "description": "SUCRE"
  },
  {
    "countryCode": "CO",
    "region": "73",
    "description": "TOLIMA"
  },
  {
    "countryCode": "CO",
    "region": "76",
    "description": "VALLE"
  },
  {
    "countryCode": "CO",
    "region": "81",
    "description": "ARAUCA"
  },
  {
    "countryCode": "CO",
    "region": "85",
    "description": "CASANARE"
  },
  {
    "countryCode": "CO",
    "region": "86",
    "description": "PUTUMAYO"
  },
  {
    "countryCode": "CO",
    "region": "88",
    "description": "SAN ANDRES"
  },
  {
    "countryCode": "CO",
    "region": "91",
    "description": "AMAZONAS"
  },
  {
    "countryCode": "CO",
    "region": "94",
    "description": "GUAINIA"
  },
  {
    "countryCode": "CO",
    "region": "95",
    "description": "GUAVIARE"
  },
  {
    "countryCode": "CO",
    "region": "97",
    "description": "VAUPES"
  },
  {
    "countryCode": "CO",
    "region": "99",
    "description": "VICHADA"
  },
  {
    "countryCode": "CR",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CS",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CU",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CV",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CX",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CY",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "CZ",
    "region": "11",
    "description": "Praha"
  },
  {
    "countryCode": "CZ",
    "region": "21",
    "description": "Stredocesky"
  },
  {
    "countryCode": "CZ",
    "region": "31",
    "description": "Jihocesky"
  },
  {
    "countryCode": "CZ",
    "region": "32",
    "description": "Plzensky"
  },
  {
    "countryCode": "CZ",
    "region": "41",
    "description": "Karlovarsky"
  },
  {
    "countryCode": "CZ",
    "region": "42",
    "description": "Ustecky"
  },
  {
    "countryCode": "CZ",
    "region": "51",
    "description": "Liberecky"
  },
  {
    "countryCode": "CZ",
    "region": "52",
    "description": "Kralovehradecky"
  },
  {
    "countryCode": "CZ",
    "region": "53",
    "description": "Pardubicky"
  },
  {
    "countryCode": "CZ",
    "region": "61",
    "description": "Vysocina"
  },
  {
    "countryCode": "CZ",
    "region": "62",
    "description": "Jihomoravsky"
  },
  {
    "countryCode": "CZ",
    "region": "71",
    "description": "Olomoucky"
  },
  {
    "countryCode": "CZ",
    "region": "72",
    "description": "Zlinsky"
  },
  {
    "countryCode": "CZ",
    "region": "81",
    "description": "Moravskoslezsky"
  },
  {
    "countryCode": "DE",
    "region": "1",
    "description": "Schleswig-Holstein"
  },
  {
    "countryCode": "DE",
    "region": "2",
    "description": "Hamburg"
  },
  {
    "countryCode": "DE",
    "region": "3",
    "description": "Lower Saxony"
  },
  {
    "countryCode": "DE",
    "region": "4",
    "description": "Bremen"
  },
  {
    "countryCode": "DE",
    "region": "5",
    "description": "Nrth Rhine Westfalia"
  },
  {
    "countryCode": "DE",
    "region": "6",
    "description": "Hesse"
  },
  {
    "countryCode": "DE",
    "region": "7",
    "description": "Rhineland Palatinate"
  },
  {
    "countryCode": "DE",
    "region": "8",
    "description": "Baden-Wurttemberg"
  },
  {
    "countryCode": "DE",
    "region": "9",
    "description": "Bavaria"
  },
  {
    "countryCode": "DE",
    "region": "10",
    "description": "Saarland"
  },
  {
    "countryCode": "DE",
    "region": "11",
    "description": "Berlin"
  },
  {
    "countryCode": "DE",
    "region": "12",
    "description": "Brandenburg"
  },
  {
    "countryCode": "DE",
    "region": "13",
    "description": "Mecklenburg-Vorpomm."
  },
  {
    "countryCode": "DE",
    "region": "14",
    "description": "Saxony"
  },
  {
    "countryCode": "DE",
    "region": "15",
    "description": "Saxony-Anhalt"
  },
  {
    "countryCode": "DE",
    "region": "16",
    "description": "Thuringia"
  },
  {
    "countryCode": "DJ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "DK",
    "region": "1",
    "description": "Copenhagen"
  },
  {
    "countryCode": "DK",
    "region": "2",
    "description": "Århus amt"
  },
  {
    "countryCode": "DK",
    "region": "3",
    "description": "Bornholm amt"
  },
  {
    "countryCode": "DK",
    "region": "4",
    "description": "Frederiksborg amt"
  },
  {
    "countryCode": "DK",
    "region": "5",
    "description": "Fyn amt"
  },
  {
    "countryCode": "DK",
    "region": "6",
    "description": "København amt"
  },
  {
    "countryCode": "DK",
    "region": "7",
    "description": "Nordjylland amt"
  },
  {
    "countryCode": "DK",
    "region": "8",
    "description": "Ribe amt"
  },
  {
    "countryCode": "DK",
    "region": "9",
    "description": "Ringkøbing amt"
  },
  {
    "countryCode": "DK",
    "region": "10",
    "description": "Roskilde amt"
  },
  {
    "countryCode": "DK",
    "region": "11",
    "description": "Sønderjylland amt"
  },
  {
    "countryCode": "DK",
    "region": "12",
    "description": "Storstrøm amt"
  },
  {
    "countryCode": "DK",
    "region": "13",
    "description": "Vejle amt"
  },
  {
    "countryCode": "DK",
    "region": "14",
    "description": "Vestsjælland amt"
  },
  {
    "countryCode": "DK",
    "region": "15",
    "description": "Viborg amt"
  },
  {
    "countryCode": "DK",
    "region": "16",
    "description": "Grønlands amt"
  },
  {
    "countryCode": "DM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "DO",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "DZ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "EC",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "EE",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "EG",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "EH",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "ER",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "ES",
    "region": "1",
    "description": "Alava"
  },
  {
    "countryCode": "ES",
    "region": "2",
    "description": "Albacete"
  },
  {
    "countryCode": "ES",
    "region": "3",
    "description": "Alicante"
  },
  {
    "countryCode": "ES",
    "region": "4",
    "description": "Almeria"
  },
  {
    "countryCode": "ES",
    "region": "5",
    "description": "Avila"
  },
  {
    "countryCode": "ES",
    "region": "6",
    "description": "Badajoz"
  },
  {
    "countryCode": "ES",
    "region": "7",
    "description": "Baleares"
  },
  {
    "countryCode": "ES",
    "region": "8",
    "description": "Barcelona"
  },
  {
    "countryCode": "ES",
    "region": "9",
    "description": "Burgos"
  },
  {
    "countryCode": "ES",
    "region": "10",
    "description": "Caceres"
  },
  {
    "countryCode": "ES",
    "region": "11",
    "description": "Cadiz"
  },
  {
    "countryCode": "ES",
    "region": "12",
    "description": "Castellon"
  },
  {
    "countryCode": "ES",
    "region": "13",
    "description": "Ciudad Real"
  },
  {
    "countryCode": "ES",
    "region": "14",
    "description": "Córdoba"
  },
  {
    "countryCode": "ES",
    "region": "15",
    "description": "La Coruña"
  },
  {
    "countryCode": "ES",
    "region": "16",
    "description": "Cuenca"
  },
  {
    "countryCode": "ES",
    "region": "17",
    "description": "Gerona"
  },
  {
    "countryCode": "ES",
    "region": "18",
    "description": "Granada"
  },
  {
    "countryCode": "ES",
    "region": "19",
    "description": "Guadalajara"
  },
  {
    "countryCode": "ES",
    "region": "20",
    "description": "Guipuzcoa"
  },
  {
    "countryCode": "ES",
    "region": "21",
    "description": "Huelva"
  },
  {
    "countryCode": "ES",
    "region": "22",
    "description": "Huesca"
  },
  {
    "countryCode": "ES",
    "region": "23",
    "description": "Jaen"
  },
  {
    "countryCode": "ES",
    "region": "24",
    "description": "Leon"
  },
  {
    "countryCode": "ES",
    "region": "25",
    "description": "Lerida"
  },
  {
    "countryCode": "ES",
    "region": "26",
    "description": "La Rioja"
  },
  {
    "countryCode": "ES",
    "region": "27",
    "description": "Lugo"
  },
  {
    "countryCode": "ES",
    "region": "28",
    "description": "Madrid"
  },
  {
    "countryCode": "ES",
    "region": "29",
    "description": "Malaga"
  },
  {
    "countryCode": "ES",
    "region": "30",
    "description": "Murcia"
  },
  {
    "countryCode": "ES",
    "region": "31",
    "description": "Navarra"
  },
  {
    "countryCode": "ES",
    "region": "32",
    "description": "Orense"
  },
  {
    "countryCode": "ES",
    "region": "33",
    "description": "Asturias"
  },
  {
    "countryCode": "ES",
    "region": "34",
    "description": "Palencia"
  },
  {
    "countryCode": "ES",
    "region": "35",
    "description": "Las Palmas"
  },
  {
    "countryCode": "ES",
    "region": "36",
    "description": "Pontevedra"
  },
  {
    "countryCode": "ES",
    "region": "37",
    "description": "Salamanca"
  },
  {
    "countryCode": "ES",
    "region": "38",
    "description": "Sta. Cruz Tenerife"
  },
  {
    "countryCode": "ES",
    "region": "39",
    "description": "Cantabria"
  },
  {
    "countryCode": "ES",
    "region": "40",
    "description": "Segovia"
  },
  {
    "countryCode": "ES",
    "region": "41",
    "description": "Sevilla"
  },
  {
    "countryCode": "ES",
    "region": "42",
    "description": "Soria"
  },
  {
    "countryCode": "ES",
    "region": "43",
    "description": "Tarragona"
  },
  {
    "countryCode": "ES",
    "region": "44",
    "description": "Teruel"
  },
  {
    "countryCode": "ES",
    "region": "45",
    "description": "Toledo"
  },
  {
    "countryCode": "ES",
    "region": "46",
    "description": "Valencia"
  },
  {
    "countryCode": "ES",
    "region": "47",
    "description": "Valladolid"
  },
  {
    "countryCode": "ES",
    "region": "48",
    "description": "Vizcaya"
  },
  {
    "countryCode": "ES",
    "region": "49",
    "description": "Zamora"
  },
  {
    "countryCode": "ES",
    "region": "50",
    "description": "Zaragoza"
  },
  {
    "countryCode": "ET",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "FI",
    "region": "1",
    "description": "Ahvenanmaa"
  },
  {
    "countryCode": "FI",
    "region": "2",
    "description": "Etelä-Suomi"
  },
  {
    "countryCode": "FI",
    "region": "3",
    "description": "Itä-Suomi"
  },
  {
    "countryCode": "FI",
    "region": "4",
    "description": "Lappi"
  },
  {
    "countryCode": "FI",
    "region": "5",
    "description": "Länsi-Suomi"
  },
  {
    "countryCode": "FI",
    "region": "6",
    "description": "Oulu"
  },
  {
    "countryCode": "FI",
    "region": "7",
    "description": "Satakunta"
  },
  {
    "countryCode": "FJ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "FK",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "FM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "FO",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "FR",
    "region": "1",
    "description": "Ain"
  },
  {
    "countryCode": "FR",
    "region": "2",
    "description": "Aisne"
  },
  {
    "countryCode": "FR",
    "region": "3",
    "description": "Allier"
  },
  {
    "countryCode": "FR",
    "region": "4",
    "description": "Alpes (Hte-Provence)"
  },
  {
    "countryCode": "FR",
    "region": "5",
    "description": "Alpes (Hautes)"
  },
  {
    "countryCode": "FR",
    "region": "6",
    "description": "Alpes-Maritimes"
  },
  {
    "countryCode": "FR",
    "region": "7",
    "description": "Ardèche"
  },
  {
    "countryCode": "FR",
    "region": "8",
    "description": "Ardennes"
  },
  {
    "countryCode": "FR",
    "region": "9",
    "description": "Ariège"
  },
  {
    "countryCode": "FR",
    "region": "10",
    "description": "Aube"
  },
  {
    "countryCode": "FR",
    "region": "100",
    "description": "RILLIEUX LA PAPE"
  },
  {
    "countryCode": "FR",
    "region": "11",
    "description": "Aude"
  },
  {
    "countryCode": "FR",
    "region": "12",
    "description": "Aveyron"
  },
  {
    "countryCode": "FR",
    "region": "13",
    "description": "Bouches-du-Rhône"
  },
  {
    "countryCode": "FR",
    "region": "14",
    "description": "Calvados"
  },
  {
    "countryCode": "FR",
    "region": "15",
    "description": "Cantal"
  },
  {
    "countryCode": "FR",
    "region": "16",
    "description": "Charente"
  },
  {
    "countryCode": "FR",
    "region": "17",
    "description": "Charente-Maritime"
  },
  {
    "countryCode": "FR",
    "region": "18",
    "description": "Cher"
  },
  {
    "countryCode": "FR",
    "region": "19",
    "description": "Corrèze"
  },
  {
    "countryCode": "FR",
    "region": "21",
    "description": "Côte-d'Or"
  },
  {
    "countryCode": "FR",
    "region": "22",
    "description": "Côtes-d'Armor"
  },
  {
    "countryCode": "FR",
    "region": "23",
    "description": "Creuse"
  },
  {
    "countryCode": "FR",
    "region": "24",
    "description": "Dordogne"
  },
  {
    "countryCode": "FR",
    "region": "25",
    "description": "Doubs"
  },
  {
    "countryCode": "FR",
    "region": "26",
    "description": "Drôme"
  },
  {
    "countryCode": "FR",
    "region": "27",
    "description": "Eure"
  },
  {
    "countryCode": "FR",
    "region": "28",
    "description": "Eure-et-Loir"
  },
  {
    "countryCode": "FR",
    "region": "29",
    "description": "Finistère"
  },
  {
    "countryCode": "FR",
    "region": "2A",
    "description": "Corse-du-Sud"
  },
  {
    "countryCode": "FR",
    "region": "2B",
    "description": "Corse-du-Nord"
  },
  {
    "countryCode": "FR",
    "region": "30",
    "description": "Gard"
  },
  {
    "countryCode": "FR",
    "region": "31",
    "description": "Garonne (Haute)"
  },
  {
    "countryCode": "FR",
    "region": "32",
    "description": "Gers"
  },
  {
    "countryCode": "FR",
    "region": "33",
    "description": "Gironde"
  },
  {
    "countryCode": "FR",
    "region": "34",
    "description": "Hérault"
  },
  {
    "countryCode": "FR",
    "region": "35",
    "description": "Ille-et-Vilaine"
  },
  {
    "countryCode": "FR",
    "region": "36",
    "description": "Indre"
  },
  {
    "countryCode": "FR",
    "region": "37",
    "description": "Indre-et-Loire"
  },
  {
    "countryCode": "FR",
    "region": "38",
    "description": "Isère"
  },
  {
    "countryCode": "FR",
    "region": "39",
    "description": "Jura"
  },
  {
    "countryCode": "FR",
    "region": "40",
    "description": "Landes"
  },
  {
    "countryCode": "FR",
    "region": "41",
    "description": "Loir-et-Cher"
  },
  {
    "countryCode": "FR",
    "region": "42",
    "description": "Loire"
  },
  {
    "countryCode": "FR",
    "region": "43",
    "description": "Loire (Haute)"
  },
  {
    "countryCode": "FR",
    "region": "44",
    "description": "Loire-Atlantique"
  },
  {
    "countryCode": "FR",
    "region": "45",
    "description": "Loiret"
  },
  {
    "countryCode": "FR",
    "region": "46",
    "description": "Lot"
  },
  {
    "countryCode": "FR",
    "region": "47",
    "description": "Lot-et-Garonne"
  },
  {
    "countryCode": "FR",
    "region": "48",
    "description": "Lozère"
  },
  {
    "countryCode": "FR",
    "region": "49",
    "description": "Maine-et-Loire"
  },
  {
    "countryCode": "FR",
    "region": "50",
    "description": "Manche"
  },
  {
    "countryCode": "FR",
    "region": "51",
    "description": "Marne"
  },
  {
    "countryCode": "FR",
    "region": "52",
    "description": "Marne (Haute)"
  },
  {
    "countryCode": "FR",
    "region": "53",
    "description": "Mayenne"
  },
  {
    "countryCode": "FR",
    "region": "54",
    "description": "Meurthe-et-Moselle"
  },
  {
    "countryCode": "FR",
    "region": "55",
    "description": "Meuse"
  },
  {
    "countryCode": "FR",
    "region": "56",
    "description": "Morbihan"
  },
  {
    "countryCode": "FR",
    "region": "57",
    "description": "Moselle"
  },
  {
    "countryCode": "FR",
    "region": "58",
    "description": "Nièvre"
  },
  {
    "countryCode": "FR",
    "region": "59",
    "description": "Nord"
  },
  {
    "countryCode": "FR",
    "region": "60",
    "description": "Oise"
  },
  {
    "countryCode": "FR",
    "region": "61",
    "description": "Orne"
  },
  {
    "countryCode": "FR",
    "region": "62",
    "description": "Pas-de-Calais"
  },
  {
    "countryCode": "FR",
    "region": "63",
    "description": "Puy-de-Dôme"
  },
  {
    "countryCode": "FR",
    "region": "64",
    "description": "Pyrénées-Atlantiques"
  },
  {
    "countryCode": "FR",
    "region": "65",
    "description": "Pyrénées (Hautes)"
  },
  {
    "countryCode": "FR",
    "region": "66",
    "description": "Pyrénées-Orientales"
  },
  {
    "countryCode": "FR",
    "region": "67",
    "description": "Bas-Rhin"
  },
  {
    "countryCode": "FR",
    "region": "68",
    "description": "Haut-Rhin"
  },
  {
    "countryCode": "FR",
    "region": "69",
    "description": "Rhône"
  },
  {
    "countryCode": "FR",
    "region": "70",
    "description": "Saône (Haute)"
  },
  {
    "countryCode": "FR",
    "region": "71",
    "description": "Saône-et-Loire"
  },
  {
    "countryCode": "FR",
    "region": "72",
    "description": "Sarthe"
  },
  {
    "countryCode": "FR",
    "region": "73",
    "description": "Savoie"
  },
  {
    "countryCode": "FR",
    "region": "74",
    "description": "Savoie (Haute)"
  },
  {
    "countryCode": "FR",
    "region": "75",
    "description": "Paris"
  },
  {
    "countryCode": "FR",
    "region": "76",
    "description": "Seine-Maritime"
  },
  {
    "countryCode": "FR",
    "region": "77",
    "description": "Seine-et-Marne"
  },
  {
    "countryCode": "FR",
    "region": "78",
    "description": "Yvelines"
  },
  {
    "countryCode": "FR",
    "region": "79",
    "description": "Sèvres (Deux)"
  },
  {
    "countryCode": "FR",
    "region": "80",
    "description": "Somme"
  },
  {
    "countryCode": "FR",
    "region": "81",
    "description": "Tarn"
  },
  {
    "countryCode": "FR",
    "region": "82",
    "description": "Tarn-et-Garonne"
  },
  {
    "countryCode": "FR",
    "region": "83",
    "description": "Var"
  },
  {
    "countryCode": "FR",
    "region": "84",
    "description": "Vaucluse"
  },
  {
    "countryCode": "FR",
    "region": "85",
    "description": "Vendée"
  },
  {
    "countryCode": "FR",
    "region": "86",
    "description": "Vienne"
  },
  {
    "countryCode": "FR",
    "region": "87",
    "description": "Vienne (Haute)"
  },
  {
    "countryCode": "FR",
    "region": "88",
    "description": "Vosges"
  },
  {
    "countryCode": "FR",
    "region": "89",
    "description": "Yonne"
  },
  {
    "countryCode": "FR",
    "region": "90",
    "description": "Territ.-de-Belfort"
  },
  {
    "countryCode": "FR",
    "region": "91",
    "description": "Essonne"
  },
  {
    "countryCode": "FR",
    "region": "92",
    "description": "Hauts-de-Seine"
  },
  {
    "countryCode": "FR",
    "region": "93",
    "description": "Seine-Saint-Denis"
  },
  {
    "countryCode": "FR",
    "region": "94",
    "description": "Val-de-Marne"
  },
  {
    "countryCode": "FR",
    "region": "95",
    "description": "Val-d'Oise"
  },
  {
    "countryCode": "FR",
    "region": "97",
    "description": "D.O.M.-T.O.M."
  },
  {
    "countryCode": "FR",
    "region": "971",
    "description": "Guadeloupe"
  },
  {
    "countryCode": "FR",
    "region": "972",
    "description": "Martinique"
  },
  {
    "countryCode": "FR",
    "region": "973",
    "description": "Guyane"
  },
  {
    "countryCode": "FR",
    "region": "974",
    "description": "Réunion"
  },
  {
    "countryCode": "FR",
    "region": "975",
    "description": "Saint-Pierre-et-Miq."
  },
  {
    "countryCode": "FR",
    "region": "976",
    "description": "Wallis-et-Futuna"
  },
  {
    "countryCode": "FR",
    "region": "99",
    "description": "Hors-France"
  },
  {
    "countryCode": "GA",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GB",
    "region": "AB",
    "description": "Aberdeenshire"
  },
  {
    "countryCode": "GB",
    "region": "AG",
    "description": "Argyllshire"
  },
  {
    "countryCode": "GB",
    "region": "AL",
    "description": "Anglesey"
  },
  {
    "countryCode": "GB",
    "region": "AM",
    "description": "Armagh"
  },
  {
    "countryCode": "GB",
    "region": "AN",
    "description": "Angus/Forfarshire"
  },
  {
    "countryCode": "GB",
    "region": "AT",
    "description": "Antrim"
  },
  {
    "countryCode": "GB",
    "region": "AY",
    "description": "Ayrshire"
  },
  {
    "countryCode": "GB",
    "region": "BE",
    "description": "Bedfordshire"
  },
  {
    "countryCode": "GB",
    "region": "BF",
    "description": "Banffshire"
  },
  {
    "countryCode": "GB",
    "region": "BK",
    "description": "Berkshire"
  },
  {
    "countryCode": "GB",
    "region": "BL",
    "description": "Belfast"
  },
  {
    "countryCode": "GB",
    "region": "BR",
    "description": "Brecknockshire"
  },
  {
    "countryCode": "GB",
    "region": "BS",
    "description": "Bath&NthEstSomerset"
  },
  {
    "countryCode": "GB",
    "region": "BT",
    "description": "Buteshire"
  },
  {
    "countryCode": "GB",
    "region": "BU",
    "description": "Buckinghamshire"
  },
  {
    "countryCode": "GB",
    "region": "BW",
    "description": "Berwickshire"
  },
  {
    "countryCode": "GB",
    "region": "CA",
    "description": "Cambridgeshire"
  },
  {
    "countryCode": "GB",
    "region": "CB",
    "description": "Carmarthenshire"
  },
  {
    "countryCode": "GB",
    "region": "CD",
    "description": "Cardiganshire"
  },
  {
    "countryCode": "GB",
    "region": "CF",
    "description": "Caernarfonshire"
  },
  {
    "countryCode": "GB",
    "region": "CH",
    "description": "Cheshire"
  },
  {
    "countryCode": "GB",
    "region": "CM",
    "description": "Cromartyshire"
  },
  {
    "countryCode": "GB",
    "region": "CN",
    "description": "Clackmannanshire"
  },
  {
    "countryCode": "GB",
    "region": "CO",
    "description": "Cornwall"
  },
  {
    "countryCode": "GB",
    "region": "CT",
    "description": "Caithness"
  },
  {
    "countryCode": "GB",
    "region": "CU",
    "description": "Cumberland"
  },
  {
    "countryCode": "GB",
    "region": "DB",
    "description": "Derbyshire"
  },
  {
    "countryCode": "GB",
    "region": "DD",
    "description": "Denbighshire"
  },
  {
    "countryCode": "GB",
    "region": "DF",
    "description": "Dumfriesshire"
  },
  {
    "countryCode": "GB",
    "region": "DN",
    "description": "Down"
  },
  {
    "countryCode": "GB",
    "region": "DO",
    "description": "Dorset"
  },
  {
    "countryCode": "GB",
    "region": "DT",
    "description": "Dunbartonshire"
  },
  {
    "countryCode": "GB",
    "region": "DU",
    "description": "Durham"
  },
  {
    "countryCode": "GB",
    "region": "DV",
    "description": "Devon"
  },
  {
    "countryCode": "GB",
    "region": "EL",
    "description": "East Lothian"
  },
  {
    "countryCode": "GB",
    "region": "ES",
    "description": "Essex"
  },
  {
    "countryCode": "GB",
    "region": "FI",
    "description": "Fife"
  },
  {
    "countryCode": "GB",
    "region": "FL",
    "description": "Flintshire"
  },
  {
    "countryCode": "GB",
    "region": "FM",
    "description": "Fermanagh"
  },
  {
    "countryCode": "GB",
    "region": "GL",
    "description": "Gloucestershire"
  },
  {
    "countryCode": "GB",
    "region": "GM",
    "description": "Greater Manchester"
  },
  {
    "countryCode": "GB",
    "region": "HA",
    "description": "Hampshire"
  },
  {
    "countryCode": "GB",
    "region": "HT",
    "description": "Hertfordshire"
  },
  {
    "countryCode": "GB",
    "region": "HU",
    "description": "Huntingdonshire"
  },
  {
    "countryCode": "GB",
    "region": "HW",
    "description": "Hereford and Worcs."
  },
  {
    "countryCode": "GB",
    "region": "IN",
    "description": "Invernesshire"
  },
  {
    "countryCode": "GB",
    "region": "IW",
    "description": "Isle of Wight"
  },
  {
    "countryCode": "GB",
    "region": "KE",
    "description": "Kent"
  },
  {
    "countryCode": "GB",
    "region": "KI",
    "description": "Kincardineshire"
  },
  {
    "countryCode": "GB",
    "region": "KK",
    "description": "Kirkcudbrightshire"
  },
  {
    "countryCode": "GB",
    "region": "KN",
    "description": "Kinross-shire"
  },
  {
    "countryCode": "GB",
    "region": "LA",
    "description": "Lancashire"
  },
  {
    "countryCode": "GB",
    "region": "LD",
    "description": "Londonderry"
  },
  {
    "countryCode": "GB",
    "region": "LE",
    "description": "Leicestershire"
  },
  {
    "countryCode": "GB",
    "region": "LI",
    "description": "Lincolnshire"
  },
  {
    "countryCode": "GB",
    "region": "LN",
    "description": "Lanarkshire"
  },
  {
    "countryCode": "GB",
    "region": "LO",
    "description": "London"
  },
  {
    "countryCode": "GB",
    "region": "MD",
    "description": "Midlothian"
  },
  {
    "countryCode": "GB",
    "region": "ME",
    "description": "Merioneth"
  },
  {
    "countryCode": "GB",
    "region": "MG",
    "description": "Mid Glamorgan"
  },
  {
    "countryCode": "GB",
    "region": "MM",
    "description": "Monmouthshire"
  },
  {
    "countryCode": "GB",
    "region": "MR",
    "description": "Morayshire"
  },
  {
    "countryCode": "GB",
    "region": "MT",
    "description": "Montgomeryshire"
  },
  {
    "countryCode": "GB",
    "region": "MX",
    "description": "Middlesex"
  },
  {
    "countryCode": "GB",
    "region": "NH",
    "description": "Northamptonshire"
  },
  {
    "countryCode": "GB",
    "region": "NK",
    "description": "Norfolk"
  },
  {
    "countryCode": "GB",
    "region": "NR",
    "description": "Nairnshire"
  },
  {
    "countryCode": "GB",
    "region": "NT",
    "description": "Nottinghamshire"
  },
  {
    "countryCode": "GB",
    "region": "NU",
    "description": "Northumberland"
  },
  {
    "countryCode": "GB",
    "region": "OR",
    "description": "Orkney"
  },
  {
    "countryCode": "GB",
    "region": "OX",
    "description": "Oxfordshire"
  },
  {
    "countryCode": "GB",
    "region": "PE",
    "description": "Peeblesshire"
  },
  {
    "countryCode": "GB",
    "region": "PM",
    "description": "Pembrokeshire"
  },
  {
    "countryCode": "GB",
    "region": "PR",
    "description": "Perthshire"
  },
  {
    "countryCode": "GB",
    "region": "RA",
    "description": "Radnorshire"
  },
  {
    "countryCode": "GB",
    "region": "RE",
    "description": "Renfrewshire"
  },
  {
    "countryCode": "GB",
    "region": "RO",
    "description": "Ross-shire"
  },
  {
    "countryCode": "GB",
    "region": "RU",
    "description": "Rutland"
  },
  {
    "countryCode": "GB",
    "region": "RX",
    "description": "Roxburghshire"
  },
  {
    "countryCode": "GB",
    "region": "SCO",
    "description": "Scotland"
  },
  {
    "countryCode": "GB",
    "region": "SE",
    "description": "East Sussex"
  },
  {
    "countryCode": "GB",
    "region": "SF",
    "description": "Selkirkshire"
  },
  {
    "countryCode": "GB",
    "region": "SG",
    "description": "South Glamorgan"
  },
  {
    "countryCode": "GB",
    "region": "SH",
    "description": "Shropshire"
  },
  {
    "countryCode": "GB",
    "region": "SK",
    "description": "Suffolk"
  },
  {
    "countryCode": "GB",
    "region": "SL",
    "description": "Shetland"
  },
  {
    "countryCode": "GB",
    "region": "SO",
    "description": "Somerset"
  },
  {
    "countryCode": "GB",
    "region": "ST",
    "description": "Staffordshire"
  },
  {
    "countryCode": "GB",
    "region": "SU",
    "description": "Sutherland"
  },
  {
    "countryCode": "GB",
    "region": "SV",
    "description": "Stirlingshire"
  },
  {
    "countryCode": "GB",
    "region": "SW",
    "description": "West Sussex"
  },
  {
    "countryCode": "GB",
    "region": "SY",
    "description": "Surrey"
  },
  {
    "countryCode": "GB",
    "region": "TY",
    "description": "Tyrone"
  },
  {
    "countryCode": "GB",
    "region": "WA",
    "description": "Warwickshire"
  },
  {
    "countryCode": "GB",
    "region": "WC",
    "description": "Worcestershire"
  },
  {
    "countryCode": "GB",
    "region": "WE",
    "description": "Westmorland"
  },
  {
    "countryCode": "GB",
    "region": "WG",
    "description": "West Glamorgan"
  },
  {
    "countryCode": "GB",
    "region": "WI",
    "description": "Wiltshire"
  },
  {
    "countryCode": "GB",
    "region": "WK",
    "description": "West Lothian"
  },
  {
    "countryCode": "GB",
    "region": "WM",
    "description": "West Midlands"
  },
  {
    "countryCode": "GB",
    "region": "WT",
    "description": "Wigtownshire"
  },
  {
    "countryCode": "GB",
    "region": "YN",
    "description": "North Yorkshire"
  },
  {
    "countryCode": "GB",
    "region": "YS",
    "description": "South Yorkshire"
  },
  {
    "countryCode": "GB",
    "region": "YW",
    "description": "West Yorkshire"
  },
  {
    "countryCode": "GD",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GE",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GF",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GH",
    "region": "1",
    "description": "East Region"
  },
  {
    "countryCode": "GH",
    "region": "2",
    "description": "West Region"
  },
  {
    "countryCode": "GI",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GL",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GN",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GP",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GQ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GR",
    "region": "1",
    "description": "Aitolia kai Akarnan."
  },
  {
    "countryCode": "GR",
    "region": "2",
    "description": "Akhaia"
  },
  {
    "countryCode": "GR",
    "region": "3",
    "description": "Argolis"
  },
  {
    "countryCode": "GR",
    "region": "4",
    "description": "Arkadhia"
  },
  {
    "countryCode": "GR",
    "region": "5",
    "description": "Arta"
  },
  {
    "countryCode": "GR",
    "region": "6",
    "description": "Attiki"
  },
  {
    "countryCode": "GR",
    "region": "7",
    "description": "Dhodhekanisos"
  },
  {
    "countryCode": "GR",
    "region": "8",
    "description": "Dhrama"
  },
  {
    "countryCode": "GR",
    "region": "9",
    "description": "Evritania"
  },
  {
    "countryCode": "GR",
    "region": "10",
    "description": "Evros"
  },
  {
    "countryCode": "GR",
    "region": "11",
    "description": "Evvoia"
  },
  {
    "countryCode": "GR",
    "region": "12",
    "description": "Florina"
  },
  {
    "countryCode": "GR",
    "region": "13",
    "description": "Fokis"
  },
  {
    "countryCode": "GR",
    "region": "14",
    "description": "Fthiotis"
  },
  {
    "countryCode": "GR",
    "region": "15",
    "description": "Grevena"
  },
  {
    "countryCode": "GR",
    "region": "16",
    "description": "Ilia"
  },
  {
    "countryCode": "GR",
    "region": "17",
    "description": "Imathia"
  },
  {
    "countryCode": "GR",
    "region": "18",
    "description": "Ioannina"
  },
  {
    "countryCode": "GR",
    "region": "19",
    "description": "Iraklion"
  },
  {
    "countryCode": "GR",
    "region": "20",
    "description": "Kardhitsa"
  },
  {
    "countryCode": "GR",
    "region": "21",
    "description": "Kastoria"
  },
  {
    "countryCode": "GR",
    "region": "22",
    "description": "Kavala"
  },
  {
    "countryCode": "GR",
    "region": "23",
    "description": "Kefallinia"
  },
  {
    "countryCode": "GR",
    "region": "24",
    "description": "Kerkira"
  },
  {
    "countryCode": "GR",
    "region": "25",
    "description": "Khalkidhiki"
  },
  {
    "countryCode": "GR",
    "region": "26",
    "description": "Khania"
  },
  {
    "countryCode": "GR",
    "region": "27",
    "description": "Khios"
  },
  {
    "countryCode": "GR",
    "region": "28",
    "description": "Kikladhes"
  },
  {
    "countryCode": "GR",
    "region": "29",
    "description": "Kilkis"
  },
  {
    "countryCode": "GR",
    "region": "30",
    "description": "Korinthia"
  },
  {
    "countryCode": "GR",
    "region": "31",
    "description": "Kozani"
  },
  {
    "countryCode": "GR",
    "region": "32",
    "description": "Lakonia"
  },
  {
    "countryCode": "GR",
    "region": "33",
    "description": "Larisa"
  },
  {
    "countryCode": "GR",
    "region": "34",
    "description": "Lasithi"
  },
  {
    "countryCode": "GR",
    "region": "35",
    "description": "Lesvos"
  },
  {
    "countryCode": "GR",
    "region": "36",
    "description": "Levkas"
  },
  {
    "countryCode": "GR",
    "region": "37",
    "description": "Magnisia"
  },
  {
    "countryCode": "GR",
    "region": "38",
    "description": "Messinia"
  },
  {
    "countryCode": "GR",
    "region": "39",
    "description": "Pella"
  },
  {
    "countryCode": "GR",
    "region": "40",
    "description": "Pieria"
  },
  {
    "countryCode": "GR",
    "region": "41",
    "description": "Piraievs"
  },
  {
    "countryCode": "GR",
    "region": "42",
    "description": "Preveza"
  },
  {
    "countryCode": "GR",
    "region": "43",
    "description": "Rethimni"
  },
  {
    "countryCode": "GR",
    "region": "44",
    "description": "Rodhopi"
  },
  {
    "countryCode": "GR",
    "region": "45",
    "description": "Samos"
  },
  {
    "countryCode": "GR",
    "region": "46",
    "description": "Serrai"
  },
  {
    "countryCode": "GR",
    "region": "47",
    "description": "Thesprotia"
  },
  {
    "countryCode": "GR",
    "region": "48",
    "description": "Thessaloniki"
  },
  {
    "countryCode": "GR",
    "region": "49",
    "description": "Trikala"
  },
  {
    "countryCode": "GR",
    "region": "50",
    "description": "Voiotia"
  },
  {
    "countryCode": "GR",
    "region": "51",
    "description": "Xanthi"
  },
  {
    "countryCode": "GR",
    "region": "52",
    "description": "Zakinthos"
  },
  {
    "countryCode": "GS",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GT",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GU",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GW",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "GY",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "HK",
    "region": "HK",
    "description": "Hong Kong Island"
  },
  {
    "countryCode": "HK",
    "region": "KLN",
    "description": "Kowloon"
  },
  {
    "countryCode": "HK",
    "region": "NT",
    "description": "New Territories"
  },
  {
    "countryCode": "HM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "HN",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "HR",
    "region": "1",
    "description": "Bjelovar-Bilogora"
  },
  {
    "countryCode": "HR",
    "region": "2",
    "description": "Stadt Zagreb"
  },
  {
    "countryCode": "HR",
    "region": "3",
    "description": "Dubrovnik-Neretva"
  },
  {
    "countryCode": "HR",
    "region": "4",
    "description": "Istra"
  },
  {
    "countryCode": "HR",
    "region": "5",
    "description": "Karlovac"
  },
  {
    "countryCode": "HR",
    "region": "6",
    "description": "Koprivnica-Krizevci"
  },
  {
    "countryCode": "HR",
    "region": "7",
    "description": "Lika-Senj"
  },
  {
    "countryCode": "HR",
    "region": "8",
    "description": "Medimurje"
  },
  {
    "countryCode": "HR",
    "region": "9",
    "description": "Osijek-Baranja"
  },
  {
    "countryCode": "HR",
    "region": "10",
    "description": "Pozega-Slavonija"
  },
  {
    "countryCode": "HR",
    "region": "11",
    "description": "Primorje-Gorski Kot."
  },
  {
    "countryCode": "HR",
    "region": "12",
    "description": "Sibenik"
  },
  {
    "countryCode": "HR",
    "region": "13",
    "description": "Sisak-Moslavina"
  },
  {
    "countryCode": "HR",
    "region": "14",
    "description": "Slavonski"
  },
  {
    "countryCode": "HR",
    "region": "15",
    "description": "Brod-Posavina"
  },
  {
    "countryCode": "HR",
    "region": "16",
    "description": "Split-Dalmatia"
  },
  {
    "countryCode": "HR",
    "region": "17",
    "description": "Varazdin"
  },
  {
    "countryCode": "HR",
    "region": "18",
    "description": "Virovitica-Podravina"
  },
  {
    "countryCode": "HR",
    "region": "19",
    "description": "Vukovar-Srijem"
  },
  {
    "countryCode": "HR",
    "region": "20",
    "description": "Zadar-Knin"
  },
  {
    "countryCode": "HR",
    "region": "21",
    "description": "Zagreb"
  },
  {
    "countryCode": "HT",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "HU",
    "region": "1",
    "description": "Bacs-Kiskun"
  },
  {
    "countryCode": "HU",
    "region": "2",
    "description": "Baranya"
  },
  {
    "countryCode": "HU",
    "region": "3",
    "description": "Bekes"
  },
  {
    "countryCode": "HU",
    "region": "4",
    "description": "Bekescsaba"
  },
  {
    "countryCode": "HU",
    "region": "5",
    "description": "Borsod-Abauj-Zemplen"
  },
  {
    "countryCode": "HU",
    "region": "6",
    "description": "Budapest"
  },
  {
    "countryCode": "HU",
    "region": "7",
    "description": "Csongrad"
  },
  {
    "countryCode": "HU",
    "region": "8",
    "description": "Debrecen"
  },
  {
    "countryCode": "HU",
    "region": "9",
    "description": "Dunaujvaros"
  },
  {
    "countryCode": "HU",
    "region": "10",
    "description": "Eger"
  },
  {
    "countryCode": "HU",
    "region": "11",
    "description": "Fejer"
  },
  {
    "countryCode": "HU",
    "region": "12",
    "description": "Gyor"
  },
  {
    "countryCode": "HU",
    "region": "13",
    "description": "Gyor-Moson-Sopron"
  },
  {
    "countryCode": "HU",
    "region": "14",
    "description": "Hajdu-Bihar"
  },
  {
    "countryCode": "HU",
    "region": "15",
    "description": "Heves"
  },
  {
    "countryCode": "HU",
    "region": "16",
    "description": "Hodmezovasarhely"
  },
  {
    "countryCode": "HU",
    "region": "17",
    "description": "Jasz-Nagykun-Szolnok"
  },
  {
    "countryCode": "HU",
    "region": "18",
    "description": "Kaposvar"
  },
  {
    "countryCode": "HU",
    "region": "19",
    "description": "Kecskemet"
  },
  {
    "countryCode": "HU",
    "region": "20",
    "description": "Komarom-Esztergom"
  },
  {
    "countryCode": "HU",
    "region": "21",
    "description": "Miskolc"
  },
  {
    "countryCode": "HU",
    "region": "22",
    "description": "Nagykanizsa"
  },
  {
    "countryCode": "HU",
    "region": "23",
    "description": "Nograd"
  },
  {
    "countryCode": "HU",
    "region": "24",
    "description": "Nyiregyhaza"
  },
  {
    "countryCode": "HU",
    "region": "25",
    "description": "Pecs"
  },
  {
    "countryCode": "HU",
    "region": "26",
    "description": "Pest"
  },
  {
    "countryCode": "HU",
    "region": "27",
    "description": "Somogy"
  },
  {
    "countryCode": "HU",
    "region": "28",
    "description": "Sopron"
  },
  {
    "countryCode": "HU",
    "region": "29",
    "description": "Szabolcs-Szat.-Bereg"
  },
  {
    "countryCode": "HU",
    "region": "30",
    "description": "Szeged"
  },
  {
    "countryCode": "HU",
    "region": "31",
    "description": "Szekesfehervar"
  },
  {
    "countryCode": "HU",
    "region": "32",
    "description": "Szolnok"
  },
  {
    "countryCode": "HU",
    "region": "33",
    "description": "Szombathely"
  },
  {
    "countryCode": "HU",
    "region": "34",
    "description": "Tatabanya"
  },
  {
    "countryCode": "HU",
    "region": "35",
    "description": "Tolna"
  },
  {
    "countryCode": "HU",
    "region": "36",
    "description": "Vas"
  },
  {
    "countryCode": "HU",
    "region": "37",
    "description": "Veszprem"
  },
  {
    "countryCode": "HU",
    "region": "38",
    "description": "Zala"
  },
  {
    "countryCode": "HU",
    "region": "39",
    "description": "Zalaegerszeg"
  },
  {
    "countryCode": "ID",
    "region": "",
    "description": ""
  },
  {
    "countryCode": "ID",
    "region": "1",
    "description": "DKI Jakarta Jakarta"
  },
  {
    "countryCode": "ID",
    "region": "2",
    "description": "Jawa Barat West Java"
  },
  {
    "countryCode": "ID",
    "region": "3",
    "description": "Jawa Tengah Central"
  },
  {
    "countryCode": "ID",
    "region": "4",
    "description": "Jawa Timur East Java"
  },
  {
    "countryCode": "ID",
    "region": "5",
    "description": "DI Yogyakarta Yogyak"
  },
  {
    "countryCode": "ID",
    "region": "6",
    "description": "DI Aceh Aceh"
  },
  {
    "countryCode": "ID",
    "region": "7",
    "description": "Sumatera Utara North"
  },
  {
    "countryCode": "ID",
    "region": "8",
    "description": "Sumatera Barat West"
  },
  {
    "countryCode": "ID",
    "region": "9",
    "description": "Riau Riau"
  },
  {
    "countryCode": "ID",
    "region": "10",
    "description": "Jambi Jambi"
  },
  {
    "countryCode": "ID",
    "region": "11",
    "description": "Sumatera Selatan Sou"
  },
  {
    "countryCode": "ID",
    "region": "12",
    "description": "Bengkulu Bengkulu"
  },
  {
    "countryCode": "ID",
    "region": "13",
    "description": "Lampung Lampung"
  },
  {
    "countryCode": "ID",
    "region": "14",
    "description": "Kalimantan Selatan S"
  },
  {
    "countryCode": "ID",
    "region": "15",
    "description": "Kalimantan Barat Wes"
  },
  {
    "countryCode": "ID",
    "region": "16",
    "description": "Kalimantan Tengah Ce"
  },
  {
    "countryCode": "ID",
    "region": "17",
    "description": "Kalimantan Timur Eas"
  },
  {
    "countryCode": "ID",
    "region": "18",
    "description": "Sulawesi Selatan Sou"
  },
  {
    "countryCode": "ID",
    "region": "19",
    "description": "Sulawesi Tenggara So"
  },
  {
    "countryCode": "ID",
    "region": "20",
    "description": "Sulawesi Tengah Cent"
  },
  {
    "countryCode": "ID",
    "region": "21",
    "description": "Sulawesi Utara North"
  },
  {
    "countryCode": "ID",
    "region": "22",
    "description": "Bali Bali"
  },
  {
    "countryCode": "ID",
    "region": "23",
    "description": "Nusa Tenggara Barat"
  },
  {
    "countryCode": "ID",
    "region": "24",
    "description": "Nusa Tenggara Timur"
  },
  {
    "countryCode": "ID",
    "region": "25",
    "description": "Maluku Maluku"
  },
  {
    "countryCode": "ID",
    "region": "26",
    "description": "Irian Jaya Irian Jay"
  },
  {
    "countryCode": "ID",
    "region": "27",
    "description": "Timor Timur East Tim"
  },
  {
    "countryCode": "ID",
    "region": "28",
    "description": "Banten"
  },
  {
    "countryCode": "IE",
    "region": "CK",
    "description": "Cork"
  },
  {
    "countryCode": "IE",
    "region": "CL",
    "description": "Clare"
  },
  {
    "countryCode": "IE",
    "region": "CV",
    "description": "Cavan"
  },
  {
    "countryCode": "IE",
    "region": "CW",
    "description": "Carlow"
  },
  {
    "countryCode": "IE",
    "region": "DB",
    "description": "Dublin"
  },
  {
    "countryCode": "IE",
    "region": "DG",
    "description": "Donegal"
  },
  {
    "countryCode": "IE",
    "region": "GW",
    "description": "Galway"
  },
  {
    "countryCode": "IE",
    "region": "KD",
    "description": "Kildare"
  },
  {
    "countryCode": "IE",
    "region": "KK",
    "description": "Kilkenny"
  },
  {
    "countryCode": "IE",
    "region": "KY",
    "description": "Kerry"
  },
  {
    "countryCode": "IE",
    "region": "LF",
    "description": "Longford"
  },
  {
    "countryCode": "IE",
    "region": "LI",
    "description": "Limerick"
  },
  {
    "countryCode": "IE",
    "region": "LM",
    "description": "Leitrim"
  },
  {
    "countryCode": "IE",
    "region": "LS",
    "description": "Laois"
  },
  {
    "countryCode": "IE",
    "region": "LT",
    "description": "Louth"
  },
  {
    "countryCode": "IE",
    "region": "MH",
    "description": "Monaghan"
  },
  {
    "countryCode": "IE",
    "region": "MT",
    "description": "Meath"
  },
  {
    "countryCode": "IE",
    "region": "MY",
    "description": "Mayo"
  },
  {
    "countryCode": "IE",
    "region": "OF",
    "description": "Offaly"
  },
  {
    "countryCode": "IE",
    "region": "RC",
    "description": "Rosscommon"
  },
  {
    "countryCode": "IE",
    "region": "SG",
    "description": "Sligo"
  },
  {
    "countryCode": "IE",
    "region": "TP",
    "description": "Tipperary"
  },
  {
    "countryCode": "IE",
    "region": "WF",
    "description": "Waterford"
  },
  {
    "countryCode": "IE",
    "region": "WK",
    "description": "Wicklow"
  },
  {
    "countryCode": "IE",
    "region": "WM",
    "description": "Westmeath"
  },
  {
    "countryCode": "IE",
    "region": "WX",
    "description": "Wexford"
  },
  {
    "countryCode": "IL",
    "region": "1",
    "description": "Central"
  },
  {
    "countryCode": "IL",
    "region": "2",
    "description": "Haifa"
  },
  {
    "countryCode": "IL",
    "region": "3",
    "description": "Jerusalem"
  },
  {
    "countryCode": "IL",
    "region": "4",
    "description": "Northern"
  },
  {
    "countryCode": "IL",
    "region": "5",
    "description": "Southern"
  },
  {
    "countryCode": "IL",
    "region": "6",
    "description": "Tel Aviv"
  },
  {
    "countryCode": "IN",
    "region": "1",
    "description": "Jammu & Kashmir"
  },
  {
    "countryCode": "IN",
    "region": "2",
    "description": "Himachal Pradesh"
  },
  {
    "countryCode": "IN",
    "region": "3",
    "description": "Punjab"
  },
  {
    "countryCode": "IN",
    "region": "4",
    "description": "Chandigarh"
  },
  {
    "countryCode": "IN",
    "region": "5",
    "description": "Uttarakhand"
  },
  {
    "countryCode": "IN",
    "region": "6",
    "description": "Haryana"
  },
  {
    "countryCode": "IN",
    "region": "7",
    "description": "Delhi"
  },
  {
    "countryCode": "IN",
    "region": "8",
    "description": "Rajasthan"
  },
  {
    "countryCode": "IN",
    "region": "9",
    "description": "Uttar Pradesh"
  },
  {
    "countryCode": "IN",
    "region": "10",
    "description": "Bihar"
  },
  {
    "countryCode": "IN",
    "region": "11",
    "description": "Sikkim"
  },
  {
    "countryCode": "IN",
    "region": "12",
    "description": "Arunachal Pradesh"
  },
  {
    "countryCode": "IN",
    "region": "13",
    "description": "Nagaland"
  },
  {
    "countryCode": "IN",
    "region": "14",
    "description": "Manipur"
  },
  {
    "countryCode": "IN",
    "region": "15",
    "description": "Mizoram"
  },
  {
    "countryCode": "IN",
    "region": "16",
    "description": "Tripura"
  },
  {
    "countryCode": "IN",
    "region": "17",
    "description": "Meghalaya"
  },
  {
    "countryCode": "IN",
    "region": "18",
    "description": "Assam"
  },
  {
    "countryCode": "IN",
    "region": "19",
    "description": "West Bengal"
  },
  {
    "countryCode": "IN",
    "region": "20",
    "description": "Jharkhand"
  },
  {
    "countryCode": "IN",
    "region": "21",
    "description": "Odisha"
  },
  {
    "countryCode": "IN",
    "region": "22",
    "description": "Chattisgarh"
  },
  {
    "countryCode": "IN",
    "region": "23",
    "description": "Madhya Pradesh"
  },
  {
    "countryCode": "IN",
    "region": "24",
    "description": "Gujarat"
  },
  {
    "countryCode": "IN",
    "region": "25",
    "description": "DNH & DD"
  },
  {
    "countryCode": "IN",
    "region": "26",
    "description": "DNH & DD"
  },
  {
    "countryCode": "IN",
    "region": "27",
    "description": "Maharashtra"
  },
  {
    "countryCode": "IN",
    "region": "28",
    "description": "Andhra Pradesh"
  },
  {
    "countryCode": "IN",
    "region": "29",
    "description": "Karnataka"
  },
  {
    "countryCode": "IN",
    "region": "30",
    "description": "Goa"
  },
  {
    "countryCode": "IN",
    "region": "31",
    "description": "Lakshadweep Islands"
  },
  {
    "countryCode": "IN",
    "region": "32",
    "description": "Kerala"
  },
  {
    "countryCode": "IN",
    "region": "33",
    "description": "Tamil Nadu"
  },
  {
    "countryCode": "IN",
    "region": "34",
    "description": "Pondicherry"
  },
  {
    "countryCode": "IN",
    "region": "35",
    "description": "Andaman & Nicobar"
  },
  {
    "countryCode": "IN",
    "region": "36",
    "description": "Telangana"
  },
  {
    "countryCode": "IN",
    "region": "37",
    "description": "Andhra Pradesh (New)"
  },
  {
    "countryCode": "IN",
    "region": "38",
    "description": "Ladakh"
  },
  {
    "countryCode": "IN",
    "region": "A1",
    "description": ""
  },
  {
    "countryCode": "IN",
    "region": "A2",
    "description": ""
  },
  {
    "countryCode": "IN",
    "region": "A3",
    "description": ""
  },
  {
    "countryCode": "IN",
    "region": "A4",
    "description": ""
  },
  {
    "countryCode": "IO",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "IQ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "IR",
    "region": "1",
    "description": "EASTERN REGION"
  },
  {
    "countryCode": "IS",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "IT",
    "region": "AG",
    "description": "Agriento"
  },
  {
    "countryCode": "IT",
    "region": "AL",
    "description": "Alessandria"
  },
  {
    "countryCode": "IT",
    "region": "AN",
    "description": "Ancona"
  },
  {
    "countryCode": "IT",
    "region": "AO",
    "description": "Aosta"
  },
  {
    "countryCode": "IT",
    "region": "AP",
    "description": "Ascoli Piceno"
  },
  {
    "countryCode": "IT",
    "region": "AQ",
    "description": "L'Aquila"
  },
  {
    "countryCode": "IT",
    "region": "AR",
    "description": "Arezzo"
  },
  {
    "countryCode": "IT",
    "region": "AT",
    "description": "Asti"
  },
  {
    "countryCode": "IT",
    "region": "AV",
    "description": "Avellino"
  },
  {
    "countryCode": "IT",
    "region": "BA",
    "description": "Bari"
  },
  {
    "countryCode": "IT",
    "region": "BG",
    "description": "Bergamo"
  },
  {
    "countryCode": "IT",
    "region": "BI",
    "description": "Biella"
  },
  {
    "countryCode": "IT",
    "region": "BL",
    "description": "Belluno"
  },
  {
    "countryCode": "IT",
    "region": "BN",
    "description": "Benevento"
  },
  {
    "countryCode": "IT",
    "region": "BO",
    "description": "Bologna"
  },
  {
    "countryCode": "IT",
    "region": "BR",
    "description": "Brindisi"
  },
  {
    "countryCode": "IT",
    "region": "BS",
    "description": "Brescia"
  },
  {
    "countryCode": "IT",
    "region": "BZ",
    "description": "Bolzano"
  },
  {
    "countryCode": "IT",
    "region": "CA",
    "description": "Cagliari"
  },
  {
    "countryCode": "IT",
    "region": "CB",
    "description": "Campobasso"
  },
  {
    "countryCode": "IT",
    "region": "CE",
    "description": "Caserta"
  },
  {
    "countryCode": "IT",
    "region": "CH",
    "description": "Chieti"
  },
  {
    "countryCode": "IT",
    "region": "CL",
    "description": "Caltanisetta"
  },
  {
    "countryCode": "IT",
    "region": "CN",
    "description": "Cuneo"
  },
  {
    "countryCode": "IT",
    "region": "CO",
    "description": "Como"
  },
  {
    "countryCode": "IT",
    "region": "CR",
    "description": "Cremona"
  },
  {
    "countryCode": "IT",
    "region": "CS",
    "description": "Cosenza"
  },
  {
    "countryCode": "IT",
    "region": "CT",
    "description": "Catania"
  },
  {
    "countryCode": "IT",
    "region": "CZ",
    "description": "Catanzaro"
  },
  {
    "countryCode": "IT",
    "region": "EN",
    "description": "Enna"
  },
  {
    "countryCode": "IT",
    "region": "FC",
    "description": "Forli/Cesana"
  },
  {
    "countryCode": "IT",
    "region": "FE",
    "description": "Ferrara"
  },
  {
    "countryCode": "IT",
    "region": "FG",
    "description": "Foggia"
  },
  {
    "countryCode": "IT",
    "region": "FI",
    "description": "Florence"
  },
  {
    "countryCode": "IT",
    "region": "FM",
    "description": "Fermo"
  },
  {
    "countryCode": "IT",
    "region": "FR",
    "description": "Frosinone"
  },
  {
    "countryCode": "IT",
    "region": "GE",
    "description": "Genova"
  },
  {
    "countryCode": "IT",
    "region": "GO",
    "description": "Gorizia"
  },
  {
    "countryCode": "IT",
    "region": "GR",
    "description": "Grosseto"
  },
  {
    "countryCode": "IT",
    "region": "IM",
    "description": "Imperia"
  },
  {
    "countryCode": "IT",
    "region": "IS",
    "description": "Isernia"
  },
  {
    "countryCode": "IT",
    "region": "KR",
    "description": "Crotone"
  },
  {
    "countryCode": "IT",
    "region": "LC",
    "description": "Lecco"
  },
  {
    "countryCode": "IT",
    "region": "LE",
    "description": "Lecce"
  },
  {
    "countryCode": "IT",
    "region": "LI",
    "description": "Livorno"
  },
  {
    "countryCode": "IT",
    "region": "LO",
    "description": "Lodi"
  },
  {
    "countryCode": "IT",
    "region": "LT",
    "description": "Latina"
  },
  {
    "countryCode": "IT",
    "region": "LU",
    "description": "Lucca"
  },
  {
    "countryCode": "IT",
    "region": "MB",
    "description": "Monza and Brianza"
  },
  {
    "countryCode": "IT",
    "region": "MC",
    "description": "Macerata"
  },
  {
    "countryCode": "IT",
    "region": "ME",
    "description": "Messina"
  },
  {
    "countryCode": "IT",
    "region": "MI",
    "description": "Milan"
  },
  {
    "countryCode": "IT",
    "region": "MN",
    "description": "Mantova"
  },
  {
    "countryCode": "IT",
    "region": "MO",
    "description": "Modena"
  },
  {
    "countryCode": "IT",
    "region": "MS",
    "description": "Massa Carrara"
  },
  {
    "countryCode": "IT",
    "region": "MT",
    "description": "Matera"
  },
  {
    "countryCode": "IT",
    "region": "NA",
    "description": "Naples"
  },
  {
    "countryCode": "IT",
    "region": "NO",
    "description": "Novara"
  },
  {
    "countryCode": "IT",
    "region": "NU",
    "description": "Nuoro"
  },
  {
    "countryCode": "IT",
    "region": "OR",
    "description": "Oristano"
  },
  {
    "countryCode": "IT",
    "region": "OT",
    "description": "Olbia-Tempio"
  },
  {
    "countryCode": "IT",
    "region": "PA",
    "description": "Palermo"
  },
  {
    "countryCode": "IT",
    "region": "PC",
    "description": "Piacenza"
  },
  {
    "countryCode": "IT",
    "region": "PD",
    "description": "Padova"
  },
  {
    "countryCode": "IT",
    "region": "PE",
    "description": "Pescara"
  },
  {
    "countryCode": "IT",
    "region": "PG",
    "description": "Perugia"
  },
  {
    "countryCode": "IT",
    "region": "PI",
    "description": "Pisa"
  },
  {
    "countryCode": "IT",
    "region": "PN",
    "description": "Pordenone"
  },
  {
    "countryCode": "IT",
    "region": "PO",
    "description": "Prato"
  },
  {
    "countryCode": "IT",
    "region": "PR",
    "description": "Parma"
  },
  {
    "countryCode": "IT",
    "region": "PT",
    "description": "Pistoia"
  },
  {
    "countryCode": "IT",
    "region": "PU",
    "description": "Pesaro-Urbino"
  },
  {
    "countryCode": "IT",
    "region": "PV",
    "description": "Pavia"
  },
  {
    "countryCode": "IT",
    "region": "PZ",
    "description": "Potenza"
  },
  {
    "countryCode": "IT",
    "region": "RA",
    "description": "Ravenna"
  },
  {
    "countryCode": "IT",
    "region": "RC",
    "description": "Reggio Calabria"
  },
  {
    "countryCode": "IT",
    "region": "RE",
    "description": "Reggio Emilia"
  },
  {
    "countryCode": "IT",
    "region": "RG",
    "description": "Ragusa"
  },
  {
    "countryCode": "IT",
    "region": "RI",
    "description": "Rieti"
  },
  {
    "countryCode": "IT",
    "region": "RM",
    "description": "Rome"
  },
  {
    "countryCode": "IT",
    "region": "RN",
    "description": "Rimini"
  },
  {
    "countryCode": "IT",
    "region": "RO",
    "description": "Rovigo"
  },
  {
    "countryCode": "IT",
    "region": "SA",
    "description": "Salerno"
  },
  {
    "countryCode": "IT",
    "region": "SI",
    "description": "Siena"
  },
  {
    "countryCode": "IT",
    "region": "SO",
    "description": "Sondrio"
  },
  {
    "countryCode": "IT",
    "region": "SP",
    "description": "La Spezia"
  },
  {
    "countryCode": "IT",
    "region": "SR",
    "description": "Siracusa"
  },
  {
    "countryCode": "IT",
    "region": "SS",
    "description": "Sassari"
  },
  {
    "countryCode": "IT",
    "region": "SU",
    "description": "Sud Sardegna"
  },
  {
    "countryCode": "IT",
    "region": "SV",
    "description": "Savona"
  },
  {
    "countryCode": "IT",
    "region": "TA",
    "description": "Taranto"
  },
  {
    "countryCode": "IT",
    "region": "TE",
    "description": "Teramo"
  },
  {
    "countryCode": "IT",
    "region": "TN",
    "description": "Trento"
  },
  {
    "countryCode": "IT",
    "region": "TO",
    "description": "Turin"
  },
  {
    "countryCode": "IT",
    "region": "TP",
    "description": "Trapani"
  },
  {
    "countryCode": "IT",
    "region": "TR",
    "description": "Terni"
  },
  {
    "countryCode": "IT",
    "region": "TS",
    "description": "Trieste"
  },
  {
    "countryCode": "IT",
    "region": "TV",
    "description": "Treviso"
  },
  {
    "countryCode": "IT",
    "region": "UD",
    "description": "Udine"
  },
  {
    "countryCode": "IT",
    "region": "VA",
    "description": "Varese"
  },
  {
    "countryCode": "IT",
    "region": "VB",
    "description": "Verbania"
  },
  {
    "countryCode": "IT",
    "region": "VC",
    "description": "Vercelli"
  },
  {
    "countryCode": "IT",
    "region": "VE",
    "description": "Venice"
  },
  {
    "countryCode": "IT",
    "region": "VI",
    "description": "Vicenza"
  },
  {
    "countryCode": "IT",
    "region": "VR",
    "description": "Verona"
  },
  {
    "countryCode": "IT",
    "region": "VT",
    "description": "Viterbo"
  },
  {
    "countryCode": "IT",
    "region": "VV",
    "description": "Vibo Valentia"
  },
  {
    "countryCode": "IV",
    "region": "1",
    "description": "Ivory Coast"
  },
  {
    "countryCode": "JM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "JO",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "JP",
    "region": "1",
    "description": "Hokkaido"
  },
  {
    "countryCode": "JP",
    "region": "2",
    "description": "Aomori"
  },
  {
    "countryCode": "JP",
    "region": "3",
    "description": "Iwate"
  },
  {
    "countryCode": "JP",
    "region": "4",
    "description": "Miyagi"
  },
  {
    "countryCode": "JP",
    "region": "5",
    "description": "Akita"
  },
  {
    "countryCode": "JP",
    "region": "6",
    "description": "Yamagata"
  },
  {
    "countryCode": "JP",
    "region": "7",
    "description": "Fukushima"
  },
  {
    "countryCode": "JP",
    "region": "8",
    "description": "Ibaraki"
  },
  {
    "countryCode": "JP",
    "region": "9",
    "description": "Tochigi"
  },
  {
    "countryCode": "JP",
    "region": "10",
    "description": "Gunma"
  },
  {
    "countryCode": "JP",
    "region": "11",
    "description": "Saitama"
  },
  {
    "countryCode": "JP",
    "region": "12",
    "description": "Chiba"
  },
  {
    "countryCode": "JP",
    "region": "13",
    "description": "Tokyo"
  },
  {
    "countryCode": "JP",
    "region": "14",
    "description": "Kanagawa"
  },
  {
    "countryCode": "JP",
    "region": "15",
    "description": "Niigata"
  },
  {
    "countryCode": "JP",
    "region": "16",
    "description": "Toyama"
  },
  {
    "countryCode": "JP",
    "region": "17",
    "description": "Ishikawa"
  },
  {
    "countryCode": "JP",
    "region": "18",
    "description": "Fukui"
  },
  {
    "countryCode": "JP",
    "region": "19",
    "description": "Yamanashi"
  },
  {
    "countryCode": "JP",
    "region": "20",
    "description": "Nagano"
  },
  {
    "countryCode": "JP",
    "region": "21",
    "description": "Gifu"
  },
  {
    "countryCode": "JP",
    "region": "22",
    "description": "Shizuoka"
  },
  {
    "countryCode": "JP",
    "region": "23",
    "description": "Aichi"
  },
  {
    "countryCode": "JP",
    "region": "24",
    "description": "Mie"
  },
  {
    "countryCode": "JP",
    "region": "25",
    "description": "Shiga"
  },
  {
    "countryCode": "JP",
    "region": "26",
    "description": "Kyoto"
  },
  {
    "countryCode": "JP",
    "region": "27",
    "description": "Osaka"
  },
  {
    "countryCode": "JP",
    "region": "28",
    "description": "Hyogo"
  },
  {
    "countryCode": "JP",
    "region": "29",
    "description": "Nara"
  },
  {
    "countryCode": "JP",
    "region": "30",
    "description": "Wakayama"
  },
  {
    "countryCode": "JP",
    "region": "31",
    "description": "Tottori"
  },
  {
    "countryCode": "JP",
    "region": "32",
    "description": "Shimane"
  },
  {
    "countryCode": "JP",
    "region": "33",
    "description": "Okayama"
  },
  {
    "countryCode": "JP",
    "region": "34",
    "description": "Hiroshima"
  },
  {
    "countryCode": "JP",
    "region": "35",
    "description": "Yamaguchi"
  },
  {
    "countryCode": "JP",
    "region": "36",
    "description": "Tokushima"
  },
  {
    "countryCode": "JP",
    "region": "37",
    "description": "Kagawa"
  },
  {
    "countryCode": "JP",
    "region": "38",
    "description": "Ehime"
  },
  {
    "countryCode": "JP",
    "region": "39",
    "description": "Kochi"
  },
  {
    "countryCode": "JP",
    "region": "40",
    "description": "Fukuoka"
  },
  {
    "countryCode": "JP",
    "region": "41",
    "description": "Saga"
  },
  {
    "countryCode": "JP",
    "region": "42",
    "description": "Nagasaki"
  },
  {
    "countryCode": "JP",
    "region": "43",
    "description": "Kumamoto"
  },
  {
    "countryCode": "JP",
    "region": "44",
    "description": "Oita"
  },
  {
    "countryCode": "JP",
    "region": "45",
    "description": "Miyazaki"
  },
  {
    "countryCode": "JP",
    "region": "46",
    "description": "Kagoshima"
  },
  {
    "countryCode": "JP",
    "region": "47",
    "description": "Okinawa"
  },
  {
    "countryCode": "KE",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "KG",
    "region": "1",
    "description": "East Region"
  },
  {
    "countryCode": "KG",
    "region": "2",
    "description": "West Region"
  },
  {
    "countryCode": "KH",
    "region": "1",
    "description": "General Region"
  },
  {
    "countryCode": "KI",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "KM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "KN",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "KO",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "KP",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "KR",
    "region": "1",
    "description": "Cheju-do"
  },
  {
    "countryCode": "KR",
    "region": "2",
    "description": "Cholla-bukto"
  },
  {
    "countryCode": "KR",
    "region": "3",
    "description": "Cholla-namdo"
  },
  {
    "countryCode": "KR",
    "region": "4",
    "description": "Ch´ungch´ong-bukto"
  },
  {
    "countryCode": "KR",
    "region": "5",
    "description": "Ch´ungch´ong-namdo"
  },
  {
    "countryCode": "KR",
    "region": "6",
    "description": "Inch´on-jikhalsi"
  },
  {
    "countryCode": "KR",
    "region": "7",
    "description": "Kangwon-do"
  },
  {
    "countryCode": "KR",
    "region": "8",
    "description": "Kwangju-jikhalsi"
  },
  {
    "countryCode": "KR",
    "region": "9",
    "description": "Kyonggi-do"
  },
  {
    "countryCode": "KR",
    "region": "10",
    "description": "Kyongsang-bukto"
  },
  {
    "countryCode": "KR",
    "region": "11",
    "description": "Kyongsang-namdo"
  },
  {
    "countryCode": "KR",
    "region": "12",
    "description": "Pusan-jikhalsi"
  },
  {
    "countryCode": "KR",
    "region": "13",
    "description": "Soul-t´ukpyolsi"
  },
  {
    "countryCode": "KR",
    "region": "14",
    "description": "Taegu-jikhalsi"
  },
  {
    "countryCode": "KR",
    "region": "15",
    "description": "Taejon-jikhalsi"
  },
  {
    "countryCode": "KW",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "KY",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "KZ",
    "region": "0",
    "description": "Almatynskaia"
  },
  {
    "countryCode": "KZ",
    "region": "1",
    "description": "Kostanaiskaia"
  },
  {
    "countryCode": "KZ",
    "region": "2",
    "description": "Severo-Kazakhstansk"
  },
  {
    "countryCode": "KZ",
    "region": "3",
    "description": "Pavlodarskaia"
  },
  {
    "countryCode": "KZ",
    "region": "4",
    "description": "Akmolinskaia"
  },
  {
    "countryCode": "KZ",
    "region": "5",
    "description": "Aktubinskaia"
  },
  {
    "countryCode": "KZ",
    "region": "6",
    "description": "Atyrauskaia"
  },
  {
    "countryCode": "KZ",
    "region": "7",
    "description": "Zapadno-Kazakhst"
  },
  {
    "countryCode": "KZ",
    "region": "8",
    "description": "Mangystayskaia"
  },
  {
    "countryCode": "KZ",
    "region": "9",
    "description": "Karagandinskaia"
  },
  {
    "countryCode": "KZ",
    "region": "10",
    "description": "Vostochno-Kazakhstan"
  },
  {
    "countryCode": "KZ",
    "region": "11",
    "description": "Gambilskaia"
  },
  {
    "countryCode": "KZ",
    "region": "12",
    "description": "Kyzilordinskaia"
  },
  {
    "countryCode": "LA",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "LB",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "LC",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "LI",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "LK",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "LR",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "LS",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "LT",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "LU",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "LV",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "LY",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MA",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MC",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MD",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MG",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MH",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MK",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "ML",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MN",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MO",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MP",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MQ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MR",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MS",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MT",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MU",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MV",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MW",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "MX",
    "region": "AGS",
    "description": "Aguascalientes"
  },
  {
    "countryCode": "MX",
    "region": "BC",
    "description": "Baja California"
  },
  {
    "countryCode": "MX",
    "region": "BCS",
    "description": "Baja California S"
  },
  {
    "countryCode": "MX",
    "region": "CHI",
    "description": "Chihuahua"
  },
  {
    "countryCode": "MX",
    "region": "CHS",
    "description": "Chiapas"
  },
  {
    "countryCode": "MX",
    "region": "CMP",
    "description": "Campeche"
  },
  {
    "countryCode": "MX",
    "region": "COA",
    "description": "Coahuila"
  },
  {
    "countryCode": "MX",
    "region": "COL",
    "description": "Colima"
  },
  {
    "countryCode": "MX",
    "region": "DF",
    "description": "Distrito Federal"
  },
  {
    "countryCode": "MX",
    "region": "DGO",
    "description": "Durango"
  },
  {
    "countryCode": "MX",
    "region": "GRO",
    "description": "Guerrero"
  },
  {
    "countryCode": "MX",
    "region": "GTO",
    "description": "Guanajuato"
  },
  {
    "countryCode": "MX",
    "region": "HGO",
    "description": "Hidalgo"
  },
  {
    "countryCode": "MX",
    "region": "JAL",
    "description": "Jalisco"
  },
  {
    "countryCode": "MX",
    "region": "MCH",
    "description": "Michoacán"
  },
  {
    "countryCode": "MX",
    "region": "MEX",
    "description": "Estado de México"
  },
  {
    "countryCode": "MX",
    "region": "MOR",
    "description": "Morelos"
  },
  {
    "countryCode": "MX",
    "region": "NAY",
    "description": "Nayarit"
  },
  {
    "countryCode": "MX",
    "region": "NL",
    "description": "Nuevo Léon"
  },
  {
    "countryCode": "MX",
    "region": "OAX",
    "description": "Oaxaca"
  },
  {
    "countryCode": "MX",
    "region": "PUE",
    "description": "Puebla"
  },
  {
    "countryCode": "MX",
    "region": "QR",
    "description": "Quintana Roo"
  },
  {
    "countryCode": "MX",
    "region": "QRO",
    "description": "Querétaro"
  },
  {
    "countryCode": "MX",
    "region": "SIN",
    "description": "Sinaloa"
  },
  {
    "countryCode": "MX",
    "region": "SLP",
    "description": "San Luis Potosí"
  },
  {
    "countryCode": "MX",
    "region": "SON",
    "description": "Sonora"
  },
  {
    "countryCode": "MX",
    "region": "TAB",
    "description": "Tabasco"
  },
  {
    "countryCode": "MX",
    "region": "TLX",
    "description": "Tlaxcala"
  },
  {
    "countryCode": "MX",
    "region": "TMS",
    "description": "Tamaulipas"
  },
  {
    "countryCode": "MX",
    "region": "VER",
    "description": "Veracruz"
  },
  {
    "countryCode": "MX",
    "region": "YUC",
    "description": "Yucatán"
  },
  {
    "countryCode": "MX",
    "region": "ZAC",
    "description": "Zacatecas"
  },
  {
    "countryCode": "MY",
    "region": "JOH",
    "description": "Johor"
  },
  {
    "countryCode": "MY",
    "region": "KED",
    "description": "Kedah"
  },
  {
    "countryCode": "MY",
    "region": "KEL",
    "description": "Kelantan"
  },
  {
    "countryCode": "MY",
    "region": "KUL",
    "description": "Kuala Lumpur"
  },
  {
    "countryCode": "MY",
    "region": "LAB",
    "description": "Labuan"
  },
  {
    "countryCode": "MY",
    "region": "MEL",
    "description": "Melaka"
  },
  {
    "countryCode": "MY",
    "region": "PAH",
    "description": "Pahang"
  },
  {
    "countryCode": "MY",
    "region": "PEL",
    "description": "Perlis"
  },
  {
    "countryCode": "MY",
    "region": "PER",
    "description": "Perak"
  },
  {
    "countryCode": "MY",
    "region": "PIN",
    "description": "Pulau Pinang"
  },
  {
    "countryCode": "MY",
    "region": "PSK",
    "description": "Wil. Persekutuan"
  },
  {
    "countryCode": "MY",
    "region": "SAB",
    "description": "Sabah"
  },
  {
    "countryCode": "MY",
    "region": "SAR",
    "description": "Sarawak"
  },
  {
    "countryCode": "MY",
    "region": "SEL",
    "description": "Selangor"
  },
  {
    "countryCode": "MY",
    "region": "SER",
    "description": "Negeri Sembilan"
  },
  {
    "countryCode": "MY",
    "region": "TRE",
    "description": "Trengganu"
  },
  {
    "countryCode": "MZ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "NA",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "NC",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "NE",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "NF",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "NG",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "NI",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "NL",
    "region": "1",
    "description": "Drenthe"
  },
  {
    "countryCode": "NL",
    "region": "2",
    "description": "Flevoland"
  },
  {
    "countryCode": "NL",
    "region": "3",
    "description": "Friesland"
  },
  {
    "countryCode": "NL",
    "region": "4",
    "description": "Gelderland"
  },
  {
    "countryCode": "NL",
    "region": "5",
    "description": "Groningen"
  },
  {
    "countryCode": "NL",
    "region": "6",
    "description": "Limburg"
  },
  {
    "countryCode": "NL",
    "region": "7",
    "description": "Noord-Brabant"
  },
  {
    "countryCode": "NL",
    "region": "8",
    "description": "Noord-Holland"
  },
  {
    "countryCode": "NL",
    "region": "9",
    "description": "Overijssel"
  },
  {
    "countryCode": "NL",
    "region": "10",
    "description": "Utrecht"
  },
  {
    "countryCode": "NL",
    "region": "11",
    "description": "Zeeland"
  },
  {
    "countryCode": "NL",
    "region": "12",
    "description": "Zuid-Holland"
  },
  {
    "countryCode": "NO",
    "region": "1",
    "description": "Østfold Fylke"
  },
  {
    "countryCode": "NO",
    "region": "2",
    "description": "Akershus Fylke"
  },
  {
    "countryCode": "NO",
    "region": "3",
    "description": "Oslo"
  },
  {
    "countryCode": "NO",
    "region": "4",
    "description": "Hedmark Fylke"
  },
  {
    "countryCode": "NO",
    "region": "5",
    "description": "Oppland Fylke"
  },
  {
    "countryCode": "NO",
    "region": "6",
    "description": "Buskerud Fylke"
  },
  {
    "countryCode": "NO",
    "region": "7",
    "description": "Vestfold Fylke"
  },
  {
    "countryCode": "NO",
    "region": "8",
    "description": "Telemark Fylke"
  },
  {
    "countryCode": "NO",
    "region": "9",
    "description": "Aust-Agder Fylke"
  },
  {
    "countryCode": "NO",
    "region": "10",
    "description": "Vest-Agder Fylke"
  },
  {
    "countryCode": "NO",
    "region": "11",
    "description": "Rogaland Fylke"
  },
  {
    "countryCode": "NO",
    "region": "12",
    "description": "Hordaland Fylke"
  },
  {
    "countryCode": "NO",
    "region": "14",
    "description": "Sogn og Fjordane F."
  },
  {
    "countryCode": "NO",
    "region": "15",
    "description": "Møre og Romsdal F."
  },
  {
    "countryCode": "NO",
    "region": "16",
    "description": "Sør-Trøndelag Fylke"
  },
  {
    "countryCode": "NO",
    "region": "17",
    "description": "Nord-Trøndelag Fylke"
  },
  {
    "countryCode": "NO",
    "region": "18",
    "description": "Nordland Fylke"
  },
  {
    "countryCode": "NO",
    "region": "19",
    "description": "Troms Fylke"
  },
  {
    "countryCode": "NO",
    "region": "20",
    "description": "Finnmark Fylke"
  },
  {
    "countryCode": "NP",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "NR",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "NU",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "NZ",
    "region": "AKL",
    "description": "Auckland"
  },
  {
    "countryCode": "NZ",
    "region": "BOP",
    "description": "Bay of Plenty"
  },
  {
    "countryCode": "NZ",
    "region": "CAN",
    "description": "Canterbury"
  },
  {
    "countryCode": "NZ",
    "region": "HAB",
    "description": "Hawke´s Bay"
  },
  {
    "countryCode": "NZ",
    "region": "MAN",
    "description": "Manawatu-Wanganui"
  },
  {
    "countryCode": "NZ",
    "region": "NTL",
    "description": "Northland"
  },
  {
    "countryCode": "NZ",
    "region": "OTA",
    "description": "Otago"
  },
  {
    "countryCode": "NZ",
    "region": "STL",
    "description": "Southland"
  },
  {
    "countryCode": "NZ",
    "region": "TAR",
    "description": "Taranaki"
  },
  {
    "countryCode": "NZ",
    "region": "WAI",
    "description": "Waikato"
  },
  {
    "countryCode": "NZ",
    "region": "WEC",
    "description": "West Coast"
  },
  {
    "countryCode": "NZ",
    "region": "WLG",
    "description": "Wellington"
  },
  {
    "countryCode": "OM",
    "region": "1",
    "description": "East region"
  },
  {
    "countryCode": "OM",
    "region": "2",
    "description": "West region"
  },
  {
    "countryCode": "PA",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "PE",
    "region": "1",
    "description": "Tumbes"
  },
  {
    "countryCode": "PE",
    "region": "2",
    "description": "Piura"
  },
  {
    "countryCode": "PE",
    "region": "3",
    "description": "Lambayeque"
  },
  {
    "countryCode": "PE",
    "region": "4",
    "description": "La Libertad"
  },
  {
    "countryCode": "PE",
    "region": "5",
    "description": "Ancash"
  },
  {
    "countryCode": "PE",
    "region": "6",
    "description": "Lima y Callao"
  },
  {
    "countryCode": "PE",
    "region": "7",
    "description": "Ica"
  },
  {
    "countryCode": "PE",
    "region": "8",
    "description": "Arequipa"
  },
  {
    "countryCode": "PE",
    "region": "9",
    "description": "Moquegua"
  },
  {
    "countryCode": "PE",
    "region": "10",
    "description": "Tacna"
  },
  {
    "countryCode": "PE",
    "region": "11",
    "description": "Amazon"
  },
  {
    "countryCode": "PE",
    "region": "12",
    "description": "Cajamarca"
  },
  {
    "countryCode": "PE",
    "region": "13",
    "description": "San Martín"
  },
  {
    "countryCode": "PE",
    "region": "14",
    "description": "Huánuco"
  },
  {
    "countryCode": "PE",
    "region": "15",
    "description": "Pasco"
  },
  {
    "countryCode": "PE",
    "region": "16",
    "description": "Junín"
  },
  {
    "countryCode": "PE",
    "region": "17",
    "description": "Huancavelica"
  },
  {
    "countryCode": "PE",
    "region": "18",
    "description": "Ayacucho"
  },
  {
    "countryCode": "PE",
    "region": "19",
    "description": "Apurimac"
  },
  {
    "countryCode": "PE",
    "region": "20",
    "description": "Cuzco"
  },
  {
    "countryCode": "PE",
    "region": "21",
    "description": "Puno"
  },
  {
    "countryCode": "PE",
    "region": "22",
    "description": "Loreto"
  },
  {
    "countryCode": "PE",
    "region": "23",
    "description": "Ucayali"
  },
  {
    "countryCode": "PE",
    "region": "24",
    "description": "Madre de Díos"
  },
  {
    "countryCode": "PF",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "PG",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "PH",
    "region": "1",
    "description": "Ilocos"
  },
  {
    "countryCode": "PH",
    "region": "2",
    "description": "Cagayan Valley"
  },
  {
    "countryCode": "PH",
    "region": "3",
    "description": "Central Luzon"
  },
  {
    "countryCode": "PH",
    "region": "4",
    "description": "South Luzon"
  },
  {
    "countryCode": "PH",
    "region": "5",
    "description": "Bicol"
  },
  {
    "countryCode": "PH",
    "region": "6",
    "description": "West Visayas"
  },
  {
    "countryCode": "PH",
    "region": "7",
    "description": "Central Visayas"
  },
  {
    "countryCode": "PH",
    "region": "8",
    "description": "Eastern Visayas"
  },
  {
    "countryCode": "PH",
    "region": "9",
    "description": "Western Mindanao"
  },
  {
    "countryCode": "PH",
    "region": "10",
    "description": "Northern Mindanao"
  },
  {
    "countryCode": "PH",
    "region": "11",
    "description": "Central Mindanao"
  },
  {
    "countryCode": "PH",
    "region": "12",
    "description": "South Mindanao"
  },
  {
    "countryCode": "PH",
    "region": "13",
    "description": "National Capital Reg"
  },
  {
    "countryCode": "PK",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "PL",
    "region": "DSL",
    "description": "Dolnoslaskie"
  },
  {
    "countryCode": "PL",
    "region": "K-P",
    "description": "Kujawsko-Pomorskie"
  },
  {
    "countryCode": "PL",
    "region": "LBL",
    "description": "Lubelskie"
  },
  {
    "countryCode": "PL",
    "region": "LBS",
    "description": "Lubuskie"
  },
  {
    "countryCode": "PL",
    "region": "LDZ",
    "description": "Lodzkie"
  },
  {
    "countryCode": "PL",
    "region": "MAL",
    "description": "Malopolskie"
  },
  {
    "countryCode": "PL",
    "region": "MAZ",
    "description": "Mazowieckie"
  },
  {
    "countryCode": "PL",
    "region": "OPO",
    "description": "Opolskie"
  },
  {
    "countryCode": "PL",
    "region": "PDK",
    "description": "Podkarpackie"
  },
  {
    "countryCode": "PL",
    "region": "PDL",
    "description": "Podlaskie"
  },
  {
    "countryCode": "PL",
    "region": "POM",
    "description": "Pomorskie"
  },
  {
    "countryCode": "PL",
    "region": "SLS",
    "description": "Slaskie"
  },
  {
    "countryCode": "PL",
    "region": "SWK",
    "description": "Swietokrzyskie"
  },
  {
    "countryCode": "PL",
    "region": "W-M",
    "description": "Warminsko-mazurskie"
  },
  {
    "countryCode": "PL",
    "region": "WLK",
    "description": "Wielkopolskie"
  },
  {
    "countryCode": "PL",
    "region": "Z-P",
    "description": "Zachodnio-Pomorskie"
  },
  {
    "countryCode": "PM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "PN",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "PR",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "PS",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "PT",
    "region": "10",
    "description": "Minho-Lima"
  },
  {
    "countryCode": "PT",
    "region": "11",
    "description": "Cávado"
  },
  {
    "countryCode": "PT",
    "region": "12",
    "description": "Ave"
  },
  {
    "countryCode": "PT",
    "region": "13",
    "description": "Grande Porto"
  },
  {
    "countryCode": "PT",
    "region": "14",
    "description": "Tâmega"
  },
  {
    "countryCode": "PT",
    "region": "15",
    "description": "Entre Douro e Vouga"
  },
  {
    "countryCode": "PT",
    "region": "16",
    "description": "Douro"
  },
  {
    "countryCode": "PT",
    "region": "17",
    "description": "Alto Trás-os-Montes"
  },
  {
    "countryCode": "PT",
    "region": "20",
    "description": "Baixo Vouga"
  },
  {
    "countryCode": "PT",
    "region": "21",
    "description": "Baixo Mondego"
  },
  {
    "countryCode": "PT",
    "region": "22",
    "description": "Pinhal Litoral"
  },
  {
    "countryCode": "PT",
    "region": "23",
    "description": "Pinhal Interior N."
  },
  {
    "countryCode": "PT",
    "region": "24",
    "description": "Pinhal Interior Sul"
  },
  {
    "countryCode": "PT",
    "region": "25",
    "description": "Dão-Lafoes"
  },
  {
    "countryCode": "PT",
    "region": "26",
    "description": "Serra da Estrela"
  },
  {
    "countryCode": "PT",
    "region": "27",
    "description": "Beira Interior Norte"
  },
  {
    "countryCode": "PT",
    "region": "28",
    "description": "Beira Interior Sul"
  },
  {
    "countryCode": "PT",
    "region": "29",
    "description": "Cova da Beira"
  },
  {
    "countryCode": "PT",
    "region": "30",
    "description": "Oeste"
  },
  {
    "countryCode": "PT",
    "region": "31",
    "description": "Grande Lisboa"
  },
  {
    "countryCode": "PT",
    "region": "32",
    "description": "Península de Setúbal"
  },
  {
    "countryCode": "PT",
    "region": "33",
    "description": "Médio Tejo"
  },
  {
    "countryCode": "PT",
    "region": "34",
    "description": "Lezíria do Tejo"
  },
  {
    "countryCode": "PT",
    "region": "40",
    "description": "Alentejo Litoral"
  },
  {
    "countryCode": "PT",
    "region": "41",
    "description": "Alto Alentejo"
  },
  {
    "countryCode": "PT",
    "region": "42",
    "description": "Alentejo Central"
  },
  {
    "countryCode": "PT",
    "region": "43",
    "description": "Baixo Alentejo"
  },
  {
    "countryCode": "PT",
    "region": "50",
    "description": "Algarve"
  },
  {
    "countryCode": "PT",
    "region": "60",
    "description": "Reg. Aut. dos Açores"
  },
  {
    "countryCode": "PT",
    "region": "70",
    "description": "Reg. Aut. da Madeira"
  },
  {
    "countryCode": "PW",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "PY",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "QA",
    "region": "1",
    "description": "North Region"
  },
  {
    "countryCode": "RE",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "RO",
    "region": "1",
    "description": "Alba"
  },
  {
    "countryCode": "RO",
    "region": "2",
    "description": "Arad"
  },
  {
    "countryCode": "RO",
    "region": "3",
    "description": "Arges"
  },
  {
    "countryCode": "RO",
    "region": "4",
    "description": "Bacau"
  },
  {
    "countryCode": "RO",
    "region": "5",
    "description": "Bihor"
  },
  {
    "countryCode": "RO",
    "region": "6",
    "description": "Bistrita-Nasaud"
  },
  {
    "countryCode": "RO",
    "region": "7",
    "description": "Botosani"
  },
  {
    "countryCode": "RO",
    "region": "8",
    "description": "Braila"
  },
  {
    "countryCode": "RO",
    "region": "9",
    "description": "Brasov"
  },
  {
    "countryCode": "RO",
    "region": "10",
    "description": "Bucuresti"
  },
  {
    "countryCode": "RO",
    "region": "11",
    "description": "Buzau"
  },
  {
    "countryCode": "RO",
    "region": "12",
    "description": "Calarasi"
  },
  {
    "countryCode": "RO",
    "region": "13",
    "description": "Caras-Severin"
  },
  {
    "countryCode": "RO",
    "region": "14",
    "description": "Cluj"
  },
  {
    "countryCode": "RO",
    "region": "15",
    "description": "Constanta"
  },
  {
    "countryCode": "RO",
    "region": "16",
    "description": "Covasna"
  },
  {
    "countryCode": "RO",
    "region": "17",
    "description": "Dimbovita"
  },
  {
    "countryCode": "RO",
    "region": "18",
    "description": "Dolj"
  },
  {
    "countryCode": "RO",
    "region": "19",
    "description": "Galati"
  },
  {
    "countryCode": "RO",
    "region": "20",
    "description": "Gorj"
  },
  {
    "countryCode": "RO",
    "region": "21",
    "description": "Giurgiu"
  },
  {
    "countryCode": "RO",
    "region": "22",
    "description": "Harghita"
  },
  {
    "countryCode": "RO",
    "region": "23",
    "description": "Hunedoara"
  },
  {
    "countryCode": "RO",
    "region": "24",
    "description": "Ialomita"
  },
  {
    "countryCode": "RO",
    "region": "25",
    "description": "Iasi"
  },
  {
    "countryCode": "RO",
    "region": "26",
    "description": "Maramures"
  },
  {
    "countryCode": "RO",
    "region": "27",
    "description": "Mehedinti"
  },
  {
    "countryCode": "RO",
    "region": "28",
    "description": "Mures"
  },
  {
    "countryCode": "RO",
    "region": "29",
    "description": "Neamt"
  },
  {
    "countryCode": "RO",
    "region": "30",
    "description": "Olt"
  },
  {
    "countryCode": "RO",
    "region": "31",
    "description": "Prahova"
  },
  {
    "countryCode": "RO",
    "region": "32",
    "description": "Salaj"
  },
  {
    "countryCode": "RO",
    "region": "33",
    "description": "Satu Mare"
  },
  {
    "countryCode": "RO",
    "region": "34",
    "description": "Sibiu"
  },
  {
    "countryCode": "RO",
    "region": "35",
    "description": "Suceava"
  },
  {
    "countryCode": "RO",
    "region": "36",
    "description": "Teleorman"
  },
  {
    "countryCode": "RO",
    "region": "37",
    "description": "Timis"
  },
  {
    "countryCode": "RO",
    "region": "38",
    "description": "Tulcea"
  },
  {
    "countryCode": "RO",
    "region": "39",
    "description": "Vaslui"
  },
  {
    "countryCode": "RO",
    "region": "40",
    "description": "Vilcea"
  },
  {
    "countryCode": "RO",
    "region": "41",
    "description": "Vrancea"
  },
  {
    "countryCode": "RS",
    "region": "0",
    "description": "Beograd"
  },
  {
    "countryCode": "RS",
    "region": "1",
    "description": "Severnobački okrug"
  },
  {
    "countryCode": "RS",
    "region": "2",
    "description": "Srednjebanatski okru"
  },
  {
    "countryCode": "RS",
    "region": "3",
    "description": "Severnobanatski okru"
  },
  {
    "countryCode": "RS",
    "region": "4",
    "description": "Južnobanatski okrug"
  },
  {
    "countryCode": "RS",
    "region": "5",
    "description": "Zapadnobački okrug"
  },
  {
    "countryCode": "RS",
    "region": "6",
    "description": "Južnobački okrug"
  },
  {
    "countryCode": "RS",
    "region": "7",
    "description": "Sremski okrug"
  },
  {
    "countryCode": "RS",
    "region": "8",
    "description": "Mačvanski okrug"
  },
  {
    "countryCode": "RS",
    "region": "9",
    "description": "Kolubarski okrug"
  },
  {
    "countryCode": "RS",
    "region": "10",
    "description": "Podunavski okrug"
  },
  {
    "countryCode": "RS",
    "region": "11",
    "description": "Braničevski okrug"
  },
  {
    "countryCode": "RS",
    "region": "12",
    "description": "Šumadijski okrug"
  },
  {
    "countryCode": "RS",
    "region": "13",
    "description": "Pomoravski okrug"
  },
  {
    "countryCode": "RS",
    "region": "14",
    "description": "Borski okrug"
  },
  {
    "countryCode": "RS",
    "region": "15",
    "description": "Zaječarski okrug"
  },
  {
    "countryCode": "RS",
    "region": "16",
    "description": "Zlatiborski okrug"
  },
  {
    "countryCode": "RS",
    "region": "17",
    "description": "Moravički okrug"
  },
  {
    "countryCode": "RS",
    "region": "18",
    "description": "Raški okrug"
  },
  {
    "countryCode": "RS",
    "region": "19",
    "description": "Rasinski okrug"
  },
  {
    "countryCode": "RS",
    "region": "20",
    "description": "Nišavski okrug"
  },
  {
    "countryCode": "RS",
    "region": "21",
    "description": "Toplički okrug"
  },
  {
    "countryCode": "RS",
    "region": "22",
    "description": "Pirotski okrug"
  },
  {
    "countryCode": "RS",
    "region": "23",
    "description": "Jablanički okrug"
  },
  {
    "countryCode": "RS",
    "region": "24",
    "description": "Pčinjski okrug"
  },
  {
    "countryCode": "RS",
    "region": "25",
    "description": "Kosovski okrug"
  },
  {
    "countryCode": "RS",
    "region": "26",
    "description": "Pećki okrug"
  },
  {
    "countryCode": "RS",
    "region": "27",
    "description": "Prizrenski okrug"
  },
  {
    "countryCode": "RS",
    "region": "28",
    "description": "Kosovsko-Mitrovački"
  },
  {
    "countryCode": "RS",
    "region": "29",
    "description": "Kosovsko-Pomoravski"
  },
  {
    "countryCode": "RS",
    "region": "KM",
    "description": "Kosovo-Metohija"
  },
  {
    "countryCode": "RS",
    "region": "VO",
    "description": "Vojvodina"
  },
  {
    "countryCode": "RU",
    "region": "1",
    "description": "Adigeja Republic"
  },
  {
    "countryCode": "RU",
    "region": "2",
    "description": "Highlands-Altay Rep."
  },
  {
    "countryCode": "RU",
    "region": "3",
    "description": "Republ.of Bashkortos"
  },
  {
    "countryCode": "RU",
    "region": "4",
    "description": "Buryat Republic"
  },
  {
    "countryCode": "RU",
    "region": "5",
    "description": "Dagestan Republic"
  },
  {
    "countryCode": "RU",
    "region": "6",
    "description": "Ingushetija Republic"
  },
  {
    "countryCode": "RU",
    "region": "7",
    "description": "Kabardino-Balkar.Rep"
  },
  {
    "countryCode": "RU",
    "region": "8",
    "description": "Kalmyk Republic"
  },
  {
    "countryCode": "RU",
    "region": "9",
    "description": "Karach.-Cherkessk Re"
  },
  {
    "countryCode": "RU",
    "region": "10",
    "description": "Karelian Republic"
  },
  {
    "countryCode": "RU",
    "region": "11",
    "description": "Komi Republic"
  },
  {
    "countryCode": "RU",
    "region": "12",
    "description": "Marijskaya Republic"
  },
  {
    "countryCode": "RU",
    "region": "13",
    "description": "Mordovian Republic"
  },
  {
    "countryCode": "RU",
    "region": "14",
    "description": "Yakutiya-Saha Rrepub"
  },
  {
    "countryCode": "RU",
    "region": "15",
    "description": "North-Osetiya Republ"
  },
  {
    "countryCode": "RU",
    "region": "16",
    "description": "Tatarstan Republic"
  },
  {
    "countryCode": "RU",
    "region": "17",
    "description": "Tuva Republic"
  },
  {
    "countryCode": "RU",
    "region": "18",
    "description": "The Udmurt Republic"
  },
  {
    "countryCode": "RU",
    "region": "19",
    "description": "Chakassky Republic"
  },
  {
    "countryCode": "RU",
    "region": "20",
    "description": "Chechenskaya Republ."
  },
  {
    "countryCode": "RU",
    "region": "21",
    "description": "Chuvash Republic"
  },
  {
    "countryCode": "RU",
    "region": "22",
    "description": "Altay Territory"
  },
  {
    "countryCode": "RU",
    "region": "23",
    "description": "Krasnodar Territory"
  },
  {
    "countryCode": "RU",
    "region": "24",
    "description": "Krasnoyarsk Territor"
  },
  {
    "countryCode": "RU",
    "region": "25",
    "description": "Primorye Territory"
  },
  {
    "countryCode": "RU",
    "region": "26",
    "description": "Stavropol Territory"
  },
  {
    "countryCode": "RU",
    "region": "27",
    "description": "Khabarovsk Territory"
  },
  {
    "countryCode": "RU",
    "region": "28",
    "description": "The Amur Area"
  },
  {
    "countryCode": "RU",
    "region": "29",
    "description": "The Arkhangelsk Area"
  },
  {
    "countryCode": "RU",
    "region": "30",
    "description": "The Astrakhan Area"
  },
  {
    "countryCode": "RU",
    "region": "31",
    "description": "The Belgorod Area"
  },
  {
    "countryCode": "RU",
    "region": "32",
    "description": "The Bryansk Area"
  },
  {
    "countryCode": "RU",
    "region": "33",
    "description": "The Vladimir Area"
  },
  {
    "countryCode": "RU",
    "region": "34",
    "description": "The Volgograd Area"
  },
  {
    "countryCode": "RU",
    "region": "35",
    "description": "The Vologda Area"
  },
  {
    "countryCode": "RU",
    "region": "36",
    "description": "The Voronezh Area"
  },
  {
    "countryCode": "RU",
    "region": "37",
    "description": "The Ivanovo Area"
  },
  {
    "countryCode": "RU",
    "region": "38",
    "description": "The Irkutsk Area"
  },
  {
    "countryCode": "RU",
    "region": "39",
    "description": "The Kaliningrad Area"
  },
  {
    "countryCode": "RU",
    "region": "40",
    "description": "The Kaluga Area"
  },
  {
    "countryCode": "RU",
    "region": "41",
    "description": "The Kamchatka Area"
  },
  {
    "countryCode": "RU",
    "region": "42",
    "description": "The Kemerovo Area"
  },
  {
    "countryCode": "RU",
    "region": "43",
    "description": "The Kirov Area"
  },
  {
    "countryCode": "RU",
    "region": "44",
    "description": "The Kostroma Area"
  },
  {
    "countryCode": "RU",
    "region": "45",
    "description": "The Kurgan Area"
  },
  {
    "countryCode": "RU",
    "region": "46",
    "description": "The Kursk Area"
  },
  {
    "countryCode": "RU",
    "region": "47",
    "description": "The Leningrad Area"
  },
  {
    "countryCode": "RU",
    "region": "48",
    "description": "The Lipetsk Area"
  },
  {
    "countryCode": "RU",
    "region": "49",
    "description": "The Magadan Area"
  },
  {
    "countryCode": "RU",
    "region": "50",
    "description": "The Moscow Area"
  },
  {
    "countryCode": "RU",
    "region": "51",
    "description": "The Murmansk Area"
  },
  {
    "countryCode": "RU",
    "region": "52",
    "description": "The Nizhniy Novgorod"
  },
  {
    "countryCode": "RU",
    "region": "53",
    "description": "The Novgorod Area"
  },
  {
    "countryCode": "RU",
    "region": "54",
    "description": "The Novosibirsk Area"
  },
  {
    "countryCode": "RU",
    "region": "55",
    "description": "The Omsk Area"
  },
  {
    "countryCode": "RU",
    "region": "56",
    "description": "The Orenburg Area"
  },
  {
    "countryCode": "RU",
    "region": "57",
    "description": "The Oryol Area"
  },
  {
    "countryCode": "RU",
    "region": "58",
    "description": "The Penza Area"
  },
  {
    "countryCode": "RU",
    "region": "59",
    "description": "The Perm Area"
  },
  {
    "countryCode": "RU",
    "region": "60",
    "description": "The Pskov Area"
  },
  {
    "countryCode": "RU",
    "region": "61",
    "description": "The Rostov Area"
  },
  {
    "countryCode": "RU",
    "region": "62",
    "description": "The Ryazan Area"
  },
  {
    "countryCode": "RU",
    "region": "63",
    "description": "The Samara Area"
  },
  {
    "countryCode": "RU",
    "region": "64",
    "description": "The Saratov Area"
  },
  {
    "countryCode": "RU",
    "region": "65",
    "description": "The Sakhalin Area"
  },
  {
    "countryCode": "RU",
    "region": "66",
    "description": "The Sverdlovsk Area"
  },
  {
    "countryCode": "RU",
    "region": "67",
    "description": "The Smolensk Area"
  },
  {
    "countryCode": "RU",
    "region": "68",
    "description": "The Tambov Area"
  },
  {
    "countryCode": "RU",
    "region": "69",
    "description": "The Tver Area"
  },
  {
    "countryCode": "RU",
    "region": "70",
    "description": "The Tomsk Area"
  },
  {
    "countryCode": "RU",
    "region": "71",
    "description": "The Tula Area"
  },
  {
    "countryCode": "RU",
    "region": "72",
    "description": "The Tyumen Area"
  },
  {
    "countryCode": "RU",
    "region": "73",
    "description": "The Ulyanovsk Area"
  },
  {
    "countryCode": "RU",
    "region": "74",
    "description": "The Chelyabinsk Area"
  },
  {
    "countryCode": "RU",
    "region": "75",
    "description": "The Chita Area"
  },
  {
    "countryCode": "RU",
    "region": "76",
    "description": "The Yaroslavl Area"
  },
  {
    "countryCode": "RU",
    "region": "77",
    "description": "c.Moscow"
  },
  {
    "countryCode": "RU",
    "region": "78",
    "description": "c.St-Peterburg"
  },
  {
    "countryCode": "RU",
    "region": "79",
    "description": "The Jewish Auton.are"
  },
  {
    "countryCode": "RU",
    "region": "80",
    "description": "Aginsk Buryat Aut.di"
  },
  {
    "countryCode": "RU",
    "region": "81",
    "description": "Komy Permjats.Aut.di"
  },
  {
    "countryCode": "RU",
    "region": "82",
    "description": "Korjacs Auton.distri"
  },
  {
    "countryCode": "RU",
    "region": "83",
    "description": "Nenekchky Auton.dist"
  },
  {
    "countryCode": "RU",
    "region": "84",
    "description": "The Taymir Auton.dis"
  },
  {
    "countryCode": "RU",
    "region": "85",
    "description": "Ust-Ordinsky Buryat"
  },
  {
    "countryCode": "RU",
    "region": "86",
    "description": "Chanti-Mansyjsky Aut"
  },
  {
    "countryCode": "RU",
    "region": "87",
    "description": "Chukotka Auton. dist"
  },
  {
    "countryCode": "RU",
    "region": "88",
    "description": "Evensky Auton.distri"
  },
  {
    "countryCode": "RU",
    "region": "89",
    "description": "Jamalo-Nenekchky Aut"
  },
  {
    "countryCode": "RW",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "SA",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "SB",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "SC",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "SD",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "SE",
    "region": "1",
    "description": "Blekinge Län"
  },
  {
    "countryCode": "SE",
    "region": "2",
    "description": "Dalarnas Län"
  },
  {
    "countryCode": "SE",
    "region": "3",
    "description": "Gotlands Län"
  },
  {
    "countryCode": "SE",
    "region": "4",
    "description": "Gävleborgs Län"
  },
  {
    "countryCode": "SE",
    "region": "5",
    "description": "Hallands Län"
  },
  {
    "countryCode": "SE",
    "region": "6",
    "description": "Jämtlands Län"
  },
  {
    "countryCode": "SE",
    "region": "7",
    "description": "Jönköpings Län"
  },
  {
    "countryCode": "SE",
    "region": "8",
    "description": "Kalmar Län"
  },
  {
    "countryCode": "SE",
    "region": "9",
    "description": "Kronobergs Län"
  },
  {
    "countryCode": "SE",
    "region": "10",
    "description": "Norrbottens Län"
  },
  {
    "countryCode": "SE",
    "region": "11",
    "description": "Skåne Län"
  },
  {
    "countryCode": "SE",
    "region": "12",
    "description": "Stockholms Län"
  },
  {
    "countryCode": "SE",
    "region": "13",
    "description": "Södermanlands Län"
  },
  {
    "countryCode": "SE",
    "region": "14",
    "description": "Uppsala Län"
  },
  {
    "countryCode": "SE",
    "region": "15",
    "description": "Värmlands Län"
  },
  {
    "countryCode": "SE",
    "region": "16",
    "description": "Västerbottens Län"
  },
  {
    "countryCode": "SE",
    "region": "17",
    "description": "Västernorrlands Län"
  },
  {
    "countryCode": "SE",
    "region": "18",
    "description": "Västmanlands Län"
  },
  {
    "countryCode": "SE",
    "region": "19",
    "description": "Västra Götalands Län"
  },
  {
    "countryCode": "SE",
    "region": "20",
    "description": "Örebro Län"
  },
  {
    "countryCode": "SE",
    "region": "21",
    "description": "Östergötlands Län"
  },
  {
    "countryCode": "SG",
    "region": "SG",
    "description": "Singapore"
  },
  {
    "countryCode": "SH",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "SI",
    "region": "1",
    "description": "Ajdovscina"
  },
  {
    "countryCode": "SI",
    "region": "2",
    "description": "Brezice"
  },
  {
    "countryCode": "SI",
    "region": "3",
    "description": "Celje"
  },
  {
    "countryCode": "SI",
    "region": "4",
    "description": "Cerknica"
  },
  {
    "countryCode": "SI",
    "region": "5",
    "description": "Crnomelj"
  },
  {
    "countryCode": "SI",
    "region": "6",
    "description": "Dravograd"
  },
  {
    "countryCode": "SI",
    "region": "7",
    "description": "Gornja Radgona"
  },
  {
    "countryCode": "SI",
    "region": "8",
    "description": "Grosuplje"
  },
  {
    "countryCode": "SI",
    "region": "9",
    "description": "Hrastnik Lasko"
  },
  {
    "countryCode": "SI",
    "region": "10",
    "description": "Idrija"
  },
  {
    "countryCode": "SI",
    "region": "11",
    "description": "Ilirska Bistrica"
  },
  {
    "countryCode": "SI",
    "region": "12",
    "description": "Izola"
  },
  {
    "countryCode": "SI",
    "region": "13",
    "description": "Jesenice"
  },
  {
    "countryCode": "SI",
    "region": "14",
    "description": "Kamnik"
  },
  {
    "countryCode": "SI",
    "region": "15",
    "description": "Kocevje"
  },
  {
    "countryCode": "SI",
    "region": "16",
    "description": "Koper"
  },
  {
    "countryCode": "SI",
    "region": "17",
    "description": "Kranj"
  },
  {
    "countryCode": "SI",
    "region": "18",
    "description": "Krsko"
  },
  {
    "countryCode": "SI",
    "region": "19",
    "description": "Lenart"
  },
  {
    "countryCode": "SI",
    "region": "20",
    "description": "Lendava"
  },
  {
    "countryCode": "SI",
    "region": "21",
    "description": "Litija"
  },
  {
    "countryCode": "SI",
    "region": "22",
    "description": "Ljubljana-Bezigrad"
  },
  {
    "countryCode": "SI",
    "region": "23",
    "description": "Ljubljana-Center"
  },
  {
    "countryCode": "SI",
    "region": "24",
    "description": "Ljubljana-Moste-Polj"
  },
  {
    "countryCode": "SI",
    "region": "25",
    "description": "Ljubljana-Siska"
  },
  {
    "countryCode": "SI",
    "region": "26",
    "description": "Ljubljana-Vic-Rudnik"
  },
  {
    "countryCode": "SI",
    "region": "27",
    "description": "Ljutomer"
  },
  {
    "countryCode": "SI",
    "region": "28",
    "description": "Logatec"
  },
  {
    "countryCode": "SI",
    "region": "29",
    "description": "Maribor"
  },
  {
    "countryCode": "SI",
    "region": "30",
    "description": "Metlika"
  },
  {
    "countryCode": "SI",
    "region": "31",
    "description": "Mozirje"
  },
  {
    "countryCode": "SI",
    "region": "32",
    "description": "Murska Sobota"
  },
  {
    "countryCode": "SI",
    "region": "33",
    "description": "Nova Gorica"
  },
  {
    "countryCode": "SI",
    "region": "34",
    "description": "Novo Mesto"
  },
  {
    "countryCode": "SI",
    "region": "35",
    "description": "Ormoz"
  },
  {
    "countryCode": "SI",
    "region": "36",
    "description": "Pesnica"
  },
  {
    "countryCode": "SI",
    "region": "37",
    "description": "Piran"
  },
  {
    "countryCode": "SI",
    "region": "38",
    "description": "Postojna"
  },
  {
    "countryCode": "SI",
    "region": "39",
    "description": "Ptuj"
  },
  {
    "countryCode": "SI",
    "region": "40",
    "description": "Radlje Ob Dravi"
  },
  {
    "countryCode": "SI",
    "region": "41",
    "description": "Radovljica"
  },
  {
    "countryCode": "SI",
    "region": "42",
    "description": "Ravne Na Koroskem"
  },
  {
    "countryCode": "SI",
    "region": "43",
    "description": "Ribnica"
  },
  {
    "countryCode": "SI",
    "region": "44",
    "description": "Ruse"
  },
  {
    "countryCode": "SI",
    "region": "45",
    "description": "Sentjur Pri Celju"
  },
  {
    "countryCode": "SI",
    "region": "46",
    "description": "Sevnica"
  },
  {
    "countryCode": "SI",
    "region": "47",
    "description": "Sezana"
  },
  {
    "countryCode": "SI",
    "region": "48",
    "description": "Skofja Loka"
  },
  {
    "countryCode": "SI",
    "region": "49",
    "description": "Slovenj Gradec"
  },
  {
    "countryCode": "SI",
    "region": "50",
    "description": "Slovenska Bistrica"
  },
  {
    "countryCode": "SI",
    "region": "51",
    "description": "Slovenske Konjice"
  },
  {
    "countryCode": "SI",
    "region": "52",
    "description": "Smarje Pri Jelsah"
  },
  {
    "countryCode": "SI",
    "region": "53",
    "description": "Tolmin"
  },
  {
    "countryCode": "SI",
    "region": "54",
    "description": "Trbovlje"
  },
  {
    "countryCode": "SI",
    "region": "55",
    "description": "Trebnje"
  },
  {
    "countryCode": "SI",
    "region": "56",
    "description": "Trzic"
  },
  {
    "countryCode": "SI",
    "region": "57",
    "description": "Velenje"
  },
  {
    "countryCode": "SI",
    "region": "58",
    "description": "Vrhnika"
  },
  {
    "countryCode": "SI",
    "region": "59",
    "description": "Zagorje Ob Savi"
  },
  {
    "countryCode": "SI",
    "region": "60",
    "description": "Zalec"
  },
  {
    "countryCode": "SJ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "SK",
    "region": "1",
    "description": "Bratislava"
  },
  {
    "countryCode": "SK",
    "region": "2",
    "description": "Zapadoslovensky"
  },
  {
    "countryCode": "SK",
    "region": "3",
    "description": "Stredoslovensky"
  },
  {
    "countryCode": "SK",
    "region": "4",
    "description": "Vychodoslovensky"
  },
  {
    "countryCode": "SL",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "SM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "SN",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "SO",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "SR",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "ST",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "SV",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "SY",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "SZ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TC",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TD",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TF",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TG",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TH",
    "region": "1",
    "description": "Amnat Charoen"
  },
  {
    "countryCode": "TH",
    "region": "2",
    "description": "Ang Thong"
  },
  {
    "countryCode": "TH",
    "region": "3",
    "description": "Buriram"
  },
  {
    "countryCode": "TH",
    "region": "4",
    "description": "Chachoengsao"
  },
  {
    "countryCode": "TH",
    "region": "5",
    "description": "Chai Nat"
  },
  {
    "countryCode": "TH",
    "region": "6",
    "description": "Chaiyaphum"
  },
  {
    "countryCode": "TH",
    "region": "7",
    "description": "Chanthaburi"
  },
  {
    "countryCode": "TH",
    "region": "8",
    "description": "Chiang Mai"
  },
  {
    "countryCode": "TH",
    "region": "9",
    "description": "Chiang Rai"
  },
  {
    "countryCode": "TH",
    "region": "10",
    "description": "Chon Buri"
  },
  {
    "countryCode": "TH",
    "region": "11",
    "description": "Chumphon"
  },
  {
    "countryCode": "TH",
    "region": "12",
    "description": "Kalasin"
  },
  {
    "countryCode": "TH",
    "region": "13",
    "description": "Kamphaeng Phet"
  },
  {
    "countryCode": "TH",
    "region": "14",
    "description": "Kanchanaburi"
  },
  {
    "countryCode": "TH",
    "region": "15",
    "description": "Khon Kaen"
  },
  {
    "countryCode": "TH",
    "region": "16",
    "description": "Krabi"
  },
  {
    "countryCode": "TH",
    "region": "17",
    "description": "Krung Thep"
  },
  {
    "countryCode": "TH",
    "region": "18",
    "description": "Mahanakhon"
  },
  {
    "countryCode": "TH",
    "region": "19",
    "description": "Lampang"
  },
  {
    "countryCode": "TH",
    "region": "20",
    "description": "Lamphun"
  },
  {
    "countryCode": "TH",
    "region": "21",
    "description": "Loei"
  },
  {
    "countryCode": "TH",
    "region": "22",
    "description": "Lop Buri"
  },
  {
    "countryCode": "TH",
    "region": "23",
    "description": "Mae Hong Son"
  },
  {
    "countryCode": "TH",
    "region": "24",
    "description": "Maha Sarakham"
  },
  {
    "countryCode": "TH",
    "region": "25",
    "description": "Mukdahan"
  },
  {
    "countryCode": "TH",
    "region": "26",
    "description": "Nakhon Nayok"
  },
  {
    "countryCode": "TH",
    "region": "27",
    "description": "Nakhon Pathom"
  },
  {
    "countryCode": "TH",
    "region": "28",
    "description": "Nakhon Phanom"
  },
  {
    "countryCode": "TH",
    "region": "29",
    "description": "Nakhon Ratchasima"
  },
  {
    "countryCode": "TH",
    "region": "30",
    "description": "Nakhon Sawan"
  },
  {
    "countryCode": "TH",
    "region": "31",
    "description": "Nakhon Si Thammarat"
  },
  {
    "countryCode": "TH",
    "region": "32",
    "description": "Nan"
  },
  {
    "countryCode": "TH",
    "region": "33",
    "description": "Narathiwat"
  },
  {
    "countryCode": "TH",
    "region": "34",
    "description": "Nong Bua Lamphu"
  },
  {
    "countryCode": "TH",
    "region": "35",
    "description": "Nong Khai"
  },
  {
    "countryCode": "TH",
    "region": "36",
    "description": "Nonthaburi"
  },
  {
    "countryCode": "TH",
    "region": "37",
    "description": "Pathum Thani"
  },
  {
    "countryCode": "TH",
    "region": "38",
    "description": "Pattani"
  },
  {
    "countryCode": "TH",
    "region": "39",
    "description": "Phangnga"
  },
  {
    "countryCode": "TH",
    "region": "40",
    "description": "Phatthalung"
  },
  {
    "countryCode": "TH",
    "region": "41",
    "description": "Phayao"
  },
  {
    "countryCode": "TH",
    "region": "42",
    "description": "Phetchabun"
  },
  {
    "countryCode": "TH",
    "region": "43",
    "description": "Phetchaburi"
  },
  {
    "countryCode": "TH",
    "region": "44",
    "description": "Phichit"
  },
  {
    "countryCode": "TH",
    "region": "45",
    "description": "Phitsanulok"
  },
  {
    "countryCode": "TH",
    "region": "46",
    "description": "Phra Nakhon Si Ayut."
  },
  {
    "countryCode": "TH",
    "region": "47",
    "description": "Phrae"
  },
  {
    "countryCode": "TH",
    "region": "48",
    "description": "Phuket"
  },
  {
    "countryCode": "TH",
    "region": "49",
    "description": "Prachin Buri"
  },
  {
    "countryCode": "TJ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TK",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TL",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TN",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TO",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TP",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TR",
    "region": "1",
    "description": "Adana"
  },
  {
    "countryCode": "TR",
    "region": "2",
    "description": "Adiyaman"
  },
  {
    "countryCode": "TR",
    "region": "3",
    "description": "Afyon"
  },
  {
    "countryCode": "TR",
    "region": "4",
    "description": "Agri"
  },
  {
    "countryCode": "TR",
    "region": "5",
    "description": "Amasya"
  },
  {
    "countryCode": "TR",
    "region": "6",
    "description": "Ankara"
  },
  {
    "countryCode": "TR",
    "region": "7",
    "description": "Antalya"
  },
  {
    "countryCode": "TR",
    "region": "8",
    "description": "Artvin"
  },
  {
    "countryCode": "TR",
    "region": "9",
    "description": "Aydin"
  },
  {
    "countryCode": "TR",
    "region": "10",
    "description": "Balikesir"
  },
  {
    "countryCode": "TR",
    "region": "11",
    "description": "Bilecik"
  },
  {
    "countryCode": "TR",
    "region": "12",
    "description": "Bingöl"
  },
  {
    "countryCode": "TR",
    "region": "13",
    "description": "Bitlis"
  },
  {
    "countryCode": "TR",
    "region": "14",
    "description": "Bolu"
  },
  {
    "countryCode": "TR",
    "region": "15",
    "description": "Burdur"
  },
  {
    "countryCode": "TR",
    "region": "16",
    "description": "Bursa"
  },
  {
    "countryCode": "TR",
    "region": "17",
    "description": "Canakkale"
  },
  {
    "countryCode": "TR",
    "region": "18",
    "description": "Cankiri"
  },
  {
    "countryCode": "TR",
    "region": "19",
    "description": "Corum"
  },
  {
    "countryCode": "TR",
    "region": "20",
    "description": "Denizli"
  },
  {
    "countryCode": "TR",
    "region": "21",
    "description": "Diyarbakir"
  },
  {
    "countryCode": "TR",
    "region": "22",
    "description": "Edirne"
  },
  {
    "countryCode": "TR",
    "region": "23",
    "description": "Elazig"
  },
  {
    "countryCode": "TR",
    "region": "24",
    "description": "Erzincan"
  },
  {
    "countryCode": "TR",
    "region": "25",
    "description": "Erzurum"
  },
  {
    "countryCode": "TR",
    "region": "26",
    "description": "Eskisehir"
  },
  {
    "countryCode": "TR",
    "region": "27",
    "description": "Gaziantep"
  },
  {
    "countryCode": "TR",
    "region": "28",
    "description": "Giresun"
  },
  {
    "countryCode": "TR",
    "region": "29",
    "description": "Gümüshane"
  },
  {
    "countryCode": "TR",
    "region": "30",
    "description": "Hakkari"
  },
  {
    "countryCode": "TR",
    "region": "31",
    "description": "Hatay"
  },
  {
    "countryCode": "TR",
    "region": "32",
    "description": "Isparta"
  },
  {
    "countryCode": "TR",
    "region": "33",
    "description": "Icel"
  },
  {
    "countryCode": "TR",
    "region": "34",
    "description": "Istanbul"
  },
  {
    "countryCode": "TR",
    "region": "35",
    "description": "Izmir"
  },
  {
    "countryCode": "TR",
    "region": "36",
    "description": "Kars"
  },
  {
    "countryCode": "TR",
    "region": "37",
    "description": "Kastamonu"
  },
  {
    "countryCode": "TR",
    "region": "38",
    "description": "Kayseri"
  },
  {
    "countryCode": "TR",
    "region": "39",
    "description": "Kirklareli"
  },
  {
    "countryCode": "TR",
    "region": "40",
    "description": "Kirshehir"
  },
  {
    "countryCode": "TR",
    "region": "41",
    "description": "Kocaeli"
  },
  {
    "countryCode": "TR",
    "region": "42",
    "description": "Konya"
  },
  {
    "countryCode": "TR",
    "region": "43",
    "description": "Kütahya"
  },
  {
    "countryCode": "TR",
    "region": "44",
    "description": "Malatya"
  },
  {
    "countryCode": "TR",
    "region": "45",
    "description": "Manisa"
  },
  {
    "countryCode": "TR",
    "region": "46",
    "description": "K.Marash"
  },
  {
    "countryCode": "TR",
    "region": "47",
    "description": "Mardin"
  },
  {
    "countryCode": "TR",
    "region": "48",
    "description": "Mugla"
  },
  {
    "countryCode": "TR",
    "region": "49",
    "description": "Mush"
  },
  {
    "countryCode": "TR",
    "region": "50",
    "description": "Nevshehir"
  },
  {
    "countryCode": "TR",
    "region": "51",
    "description": "Nigde"
  },
  {
    "countryCode": "TR",
    "region": "52",
    "description": "Ordu"
  },
  {
    "countryCode": "TR",
    "region": "53",
    "description": "Rize"
  },
  {
    "countryCode": "TR",
    "region": "54",
    "description": "Sakarya"
  },
  {
    "countryCode": "TR",
    "region": "55",
    "description": "Samsun"
  },
  {
    "countryCode": "TR",
    "region": "56",
    "description": "Siirt"
  },
  {
    "countryCode": "TR",
    "region": "57",
    "description": "Sinop"
  },
  {
    "countryCode": "TR",
    "region": "58",
    "description": "Sivas"
  },
  {
    "countryCode": "TR",
    "region": "59",
    "description": "Tekirdag"
  },
  {
    "countryCode": "TR",
    "region": "60",
    "description": "Tokat"
  },
  {
    "countryCode": "TR",
    "region": "61",
    "description": "Trabzon"
  },
  {
    "countryCode": "TR",
    "region": "62",
    "description": "Tunceli"
  },
  {
    "countryCode": "TR",
    "region": "63",
    "description": "Shanliurfa"
  },
  {
    "countryCode": "TR",
    "region": "64",
    "description": "Ushak"
  },
  {
    "countryCode": "TR",
    "region": "65",
    "description": "Van"
  },
  {
    "countryCode": "TR",
    "region": "66",
    "description": "Yozgat"
  },
  {
    "countryCode": "TR",
    "region": "67",
    "description": "Zonguldak"
  },
  {
    "countryCode": "TR",
    "region": "68",
    "description": "Aksaray"
  },
  {
    "countryCode": "TR",
    "region": "69",
    "description": "Bayburt"
  },
  {
    "countryCode": "TR",
    "region": "70",
    "description": "Karaman"
  },
  {
    "countryCode": "TR",
    "region": "71",
    "description": "Kirikkale"
  },
  {
    "countryCode": "TR",
    "region": "72",
    "description": "Batman"
  },
  {
    "countryCode": "TR",
    "region": "73",
    "description": "Shirnak"
  },
  {
    "countryCode": "TR",
    "region": "74",
    "description": "Bartin"
  },
  {
    "countryCode": "TR",
    "region": "75",
    "description": "Ardahan"
  },
  {
    "countryCode": "TR",
    "region": "76",
    "description": "Igdir"
  },
  {
    "countryCode": "TR",
    "region": "77",
    "description": "Yalova"
  },
  {
    "countryCode": "TT",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TV",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "TW",
    "region": "FJN",
    "description": "Fu-chien"
  },
  {
    "countryCode": "TW",
    "region": "KSH",
    "description": "Kao-hsiung"
  },
  {
    "countryCode": "TW",
    "region": "TPE",
    "description": "T´ai-pei"
  },
  {
    "countryCode": "TW",
    "region": "TWN",
    "description": "Taiwan"
  },
  {
    "countryCode": "TZ",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "UA",
    "region": "CHG",
    "description": "Chernigivs'ka"
  },
  {
    "countryCode": "UA",
    "region": "CHR",
    "description": "Cherkas'ka"
  },
  {
    "countryCode": "UA",
    "region": "CHV",
    "description": "Chernovits'ka"
  },
  {
    "countryCode": "UA",
    "region": "DNP",
    "description": "Dnipropetrovs'ka"
  },
  {
    "countryCode": "UA",
    "region": "DON",
    "description": "Donets'ka"
  },
  {
    "countryCode": "UA",
    "region": "HAR",
    "description": "Harkivs'ka"
  },
  {
    "countryCode": "UA",
    "region": "HML",
    "description": "Hmel'nits'ka"
  },
  {
    "countryCode": "UA",
    "region": "HRS",
    "description": "Hersons'ka"
  },
  {
    "countryCode": "UA",
    "region": "IVF",
    "description": "Ivano-Frankivs'ka"
  },
  {
    "countryCode": "UA",
    "region": "KIE",
    "description": "Kievs'ka"
  },
  {
    "countryCode": "UA",
    "region": "KIR",
    "description": "Kirovograds'ka"
  },
  {
    "countryCode": "UA",
    "region": "KRM",
    "description": "Respublika Krim"
  },
  {
    "countryCode": "UA",
    "region": "L'V",
    "description": "L'vivsbka"
  },
  {
    "countryCode": "UA",
    "region": "LUG",
    "description": "Lugans'ka"
  },
  {
    "countryCode": "UA",
    "region": "MIK",
    "description": "Mikolaivs'ka"
  },
  {
    "countryCode": "UA",
    "region": "M_K",
    "description": "m.Kiev"
  },
  {
    "countryCode": "UA",
    "region": "M_S",
    "description": "m.Sevastopil'"
  },
  {
    "countryCode": "UA",
    "region": "ODS",
    "description": "Odes'ka"
  },
  {
    "countryCode": "UA",
    "region": "POL",
    "description": "Poltavs'ka"
  },
  {
    "countryCode": "UA",
    "region": "RIV",
    "description": "Rivnens'ka"
  },
  {
    "countryCode": "UA",
    "region": "SUM",
    "description": "Sums'ka"
  },
  {
    "countryCode": "UA",
    "region": "TER",
    "description": "Ternopil's'ka"
  },
  {
    "countryCode": "UA",
    "region": "VIN",
    "description": "Vinnits'ka"
  },
  {
    "countryCode": "UA",
    "region": "VOL",
    "description": "Volins'ka"
  },
  {
    "countryCode": "UA",
    "region": "ZAK",
    "description": "Zakarpats'ka"
  },
  {
    "countryCode": "UA",
    "region": "ZAP",
    "description": "Zaporiz'ka"
  },
  {
    "countryCode": "UA",
    "region": "ZHI",
    "description": "Zhitomirs'ka"
  },
  {
    "countryCode": "UG",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "UM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "US",
    "region": "AK",
    "description": "Alaska"
  },
  {
    "countryCode": "US",
    "region": "AL",
    "description": "Alabama"
  },
  {
    "countryCode": "US",
    "region": "AR",
    "description": "Arkansas"
  },
  {
    "countryCode": "US",
    "region": "AS",
    "description": "American Samoa"
  },
  {
    "countryCode": "US",
    "region": "AZ",
    "description": "Arizona"
  },
  {
    "countryCode": "US",
    "region": "CA",
    "description": "California"
  },
  {
    "countryCode": "US",
    "region": "CO",
    "description": "Colorado"
  },
  {
    "countryCode": "US",
    "region": "CT",
    "description": "Connecticut"
  },
  {
    "countryCode": "US",
    "region": "DC",
    "description": "District of Columbia"
  },
  {
    "countryCode": "US",
    "region": "DE",
    "description": "Delaware"
  },
  {
    "countryCode": "US",
    "region": "FL",
    "description": "Florida"
  },
  {
    "countryCode": "US",
    "region": "GA",
    "description": "Georgia"
  },
  {
    "countryCode": "US",
    "region": "GU",
    "description": "Guam"
  },
  {
    "countryCode": "US",
    "region": "HI",
    "description": "Hawaii"
  },
  {
    "countryCode": "US",
    "region": "IA",
    "description": "Iowa"
  },
  {
    "countryCode": "US",
    "region": "ID",
    "description": "Idaho"
  },
  {
    "countryCode": "US",
    "region": "IL",
    "description": "Illinois"
  },
  {
    "countryCode": "US",
    "region": "IN",
    "description": "Indiana"
  },
  {
    "countryCode": "US",
    "region": "KS",
    "description": "Kansas"
  },
  {
    "countryCode": "US",
    "region": "KY",
    "description": "Kentucky"
  },
  {
    "countryCode": "US",
    "region": "LA",
    "description": "Louisiana"
  },
  {
    "countryCode": "US",
    "region": "MA",
    "description": "Massachusetts"
  },
  {
    "countryCode": "US",
    "region": "MD",
    "description": "Maryland"
  },
  {
    "countryCode": "US",
    "region": "ME",
    "description": "Maine"
  },
  {
    "countryCode": "US",
    "region": "MI",
    "description": "Michigan"
  },
  {
    "countryCode": "US",
    "region": "MN",
    "description": "Minnesota"
  },
  {
    "countryCode": "US",
    "region": "MO",
    "description": "Missouri"
  },
  {
    "countryCode": "US",
    "region": "MP",
    "description": "Northern Mariana Isl"
  },
  {
    "countryCode": "US",
    "region": "MS",
    "description": "Mississippi"
  },
  {
    "countryCode": "US",
    "region": "MT",
    "description": "Montana"
  },
  {
    "countryCode": "US",
    "region": "NC",
    "description": "North Carolina"
  },
  {
    "countryCode": "US",
    "region": "ND",
    "description": "North Dakota"
  },
  {
    "countryCode": "US",
    "region": "NE",
    "description": "Nebraska"
  },
  {
    "countryCode": "US",
    "region": "NH",
    "description": "New Hampshire"
  },
  {
    "countryCode": "US",
    "region": "NJ",
    "description": "New Jersey"
  },
  {
    "countryCode": "US",
    "region": "NM",
    "description": "New Mexico"
  },
  {
    "countryCode": "US",
    "region": "NV",
    "description": "Nevada"
  },
  {
    "countryCode": "US",
    "region": "NY",
    "description": "New York"
  },
  {
    "countryCode": "US",
    "region": "OH",
    "description": "Ohio"
  },
  {
    "countryCode": "US",
    "region": "OK",
    "description": "Oklahoma"
  },
  {
    "countryCode": "US",
    "region": "OR",
    "description": "Oregon"
  },
  {
    "countryCode": "US",
    "region": "PA",
    "description": "Pennsylvania"
  },
  {
    "countryCode": "US",
    "region": "PR",
    "description": "Puerto Rico"
  },
  {
    "countryCode": "US",
    "region": "RI",
    "description": "Rhode Island"
  },
  {
    "countryCode": "US",
    "region": "SC",
    "description": "South Carolina"
  },
  {
    "countryCode": "US",
    "region": "SD",
    "description": "South Dakota"
  },
  {
    "countryCode": "US",
    "region": "TN",
    "description": "Tennessee"
  },
  {
    "countryCode": "US",
    "region": "TX",
    "description": "Texas"
  },
  {
    "countryCode": "US",
    "region": "UT",
    "description": "Utah"
  },
  {
    "countryCode": "US",
    "region": "VA",
    "description": "Virginia"
  },
  {
    "countryCode": "US",
    "region": "VI",
    "description": "Virgin Islands"
  },
  {
    "countryCode": "US",
    "region": "VT",
    "description": "Vermont"
  },
  {
    "countryCode": "US",
    "region": "WA",
    "description": "Washington"
  },
  {
    "countryCode": "US",
    "region": "WI",
    "description": "Wisconsin"
  },
  {
    "countryCode": "US",
    "region": "WV",
    "description": "West Virginia"
  },
  {
    "countryCode": "US",
    "region": "WY",
    "description": "Wyoming"
  },
  {
    "countryCode": "UY",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "UZ",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "VA",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "VC",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "VE",
    "region": "AMA",
    "description": "Amazon"
  },
  {
    "countryCode": "VE",
    "region": "ANZ",
    "description": "Anzoategui"
  },
  {
    "countryCode": "VE",
    "region": "APU",
    "description": "Apure"
  },
  {
    "countryCode": "VE",
    "region": "ARA",
    "description": "Aragua"
  },
  {
    "countryCode": "VE",
    "region": "BAR",
    "description": "Barinas"
  },
  {
    "countryCode": "VE",
    "region": "BOL",
    "description": "Bolivar"
  },
  {
    "countryCode": "VE",
    "region": "CAR",
    "description": "Carabobo"
  },
  {
    "countryCode": "VE",
    "region": "COJ",
    "description": "Cojedes"
  },
  {
    "countryCode": "VE",
    "region": "DA",
    "description": "Delta Amacuro"
  },
  {
    "countryCode": "VE",
    "region": "DF",
    "description": "Distrito Federal"
  },
  {
    "countryCode": "VE",
    "region": "FAL",
    "description": "Falcon"
  },
  {
    "countryCode": "VE",
    "region": "GUA",
    "description": "Guarico"
  },
  {
    "countryCode": "VE",
    "region": "LAR",
    "description": "Lara"
  },
  {
    "countryCode": "VE",
    "region": "MER",
    "description": "Merida"
  },
  {
    "countryCode": "VE",
    "region": "MIR",
    "description": "Miranda"
  },
  {
    "countryCode": "VE",
    "region": "MON",
    "description": "Monagas"
  },
  {
    "countryCode": "VE",
    "region": "NE",
    "description": "Nueva Esparta"
  },
  {
    "countryCode": "VE",
    "region": "POR",
    "description": "Portuguesa"
  },
  {
    "countryCode": "VE",
    "region": "SUC",
    "description": "Sucre"
  },
  {
    "countryCode": "VE",
    "region": "TAC",
    "description": "Tachira"
  },
  {
    "countryCode": "VE",
    "region": "TRU",
    "description": "Trujillo"
  },
  {
    "countryCode": "VE",
    "region": "VAR",
    "description": "Vargas"
  },
  {
    "countryCode": "VE",
    "region": "YAR",
    "description": "Yaracuy"
  },
  {
    "countryCode": "VE",
    "region": "ZUL",
    "description": "Zulia"
  },
  {
    "countryCode": "VG",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "VI",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "VN",
    "region": "1",
    "description": "GENERAL"
  },
  {
    "countryCode": "VU",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "WF",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "WS",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "YE",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "YT",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "YU",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "ZA",
    "region": "EC",
    "description": "Eastern Cape"
  },
  {
    "countryCode": "ZA",
    "region": "FS",
    "description": "Freestate"
  },
  {
    "countryCode": "ZA",
    "region": "GP",
    "description": "Gauteng"
  },
  {
    "countryCode": "ZA",
    "region": "KZN",
    "description": "Kwazulu/Natal"
  },
  {
    "countryCode": "ZA",
    "region": "MP",
    "description": "Mpumalanga"
  },
  {
    "countryCode": "ZA",
    "region": "NC",
    "description": "Northern Cape"
  },
  {
    "countryCode": "ZA",
    "region": "NP",
    "description": "Northern Province"
  },
  {
    "countryCode": "ZA",
    "region": "NW",
    "description": "North-West"
  },
  {
    "countryCode": "ZA",
    "region": "WC",
    "description": "Western Cape"
  },
  {
    "countryCode": "ZM",
    "region": "1",
    "description": "Region 1"
  },
  {
    "countryCode": "ZW",
    "region": "1",
    "description": "Region 1"
  }
];

export const getRegionsForCountry = (countryCode) => {
    if (!countryCode) return [];
    return regionData.filter(r => r.countryCode === countryCode);
};
